/****************************************************
 * Module Name:  pageBody.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Routes, Route, Link, Navigate } from "react-router-dom";
import { Constants } from "./../../utility/constants";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import { Avatar, Box } from "@mui/material";
import UserMaster from "../master/userMaster";
import WelcomeDashboard from "../dashboard/welcomeDashboard";
import EmployeeMaster from "../master/employeeMaster";
import CustomerMaster from "../master/customerMaster";
import BrokerMaster from "../master/brokerMaster";
import LabMaster from "../master/labMaster";
import TradingcompanyMaster from "../master/tradingcompanyMaster";
import CluletMaster from "../master/cluletMaster";
import Stock from "../operations/stock";
import EyecleanMaster from "./../genericmaster/eyecleanMaster";
import StoneJourneyProcessMaster from "../genericmaster/stoneJourneyProcessMaster";
import InclusionMaster from "./../genericmaster/inclusionMaster";
import LusterMaster from "./../genericmaster/lusterMaster";
import TingeMaster from "./../genericmaster/tingeMaster";
import HNAMaster from "./../genericmaster/hnaMaster";
import OpenMaster from "./../genericmaster/openMaster";
import MilkyMaster from "./../genericmaster/milkyMaster";
import ShadeMaster from "./../genericmaster/shadeMaster";
import KeytosymbolMaster from "./../genericmaster/keytosymbolMaster";
import BusinesstypeMaster from "./../genericmaster/businesstypeMaster";
import QualityMaster from "./../genericmaster/qualityMaster";
import ExchangerateMaster from "./../genericmaster/exchangerateMaster";
import SizeMaster from "./../genericmaster/sizeMaster";
import CutMaster from "./../genericmaster/cutMaster";
import FloMaster from "./../genericmaster/floMaster";
import ShapeMaster from "./../genericmaster/shapeMaster";
import PolMaster from "./../genericmaster/polMaster";
import ColorMaster from "./../genericmaster/colorMaster";
import { FancyColorMaster } from "../genericmaster/fancyColorMaster";
import ClarityMaster from "./../genericmaster/clarityMaster";
import SymMaster from "./../genericmaster/symMaster";
import CutpolsymMaster from "./../genericmaster/cutpolsymMaster";

import WorkerMaster from "../workermaster/workerMaster";
import IGIMaster from "../workermaster/igiMaster";
import HRDMaster from "../workermaster/hrdmaster";
import WorkerSetting from "../workermaster/workerSettings";

import DesignationMaster from "./../utilitymaster/designationMaster";
import LocationMaster from "./../utilitymaster/locationMaster";
import CountryMaster from "../utilitymaster/countryMaster";
import StonestatusMaster from "../utilitymaster/stonestatusMaster";

import SettingsMaster from "../settings/settingsMaster";
import UsersettingsMaster from "../settings/userSettingsMaster";

import Help from "./../help/help";
import LabTest from "../operations/labTest";
import StoneLabstatusMaster from "../utilitymaster/stoneLabstatusMaster";
import ReCheck from "../operations/recheckMaster";
import MemoMaster from "../operations/memoMaster";
import MemostatusMaster from "../utilitymaster/memostatusMaster";
import UserReport from "../report/userReport";
import StoneReport from "../report/stoneReport";
import LabTestReport from "../report/labTestReport";
import PendingReportReceived from "../report/pendingReportReceivedReport";
import PendingStoneReceived from "../report/pendingStoneReceivedReport";
import StoneHistoryReport from "../report/stoneHistoryReport";
import MixShapeMaster from "../mixDiamondSales/mixShapeMaster";
import MixBucketMaster from "../mixDiamondSales/mixBucketMaster";
import MixClarityMaster from "../mixDiamondSales/mixClarityMaster";
import MixColorMaster from "../mixDiamondSales/mixColorMaster";
import MixPurchaseMaster from "../mixDiamondSales/mixPurchaseMaster";
import MixSalesMaster from "../mixDiamondSales/mixSalesMaster";
import MixViewStockMaster from "../mixDiamondSales/mixViewStockMaster";
import MixSizeMaster from "../mixDiamondSales/mixSizeMaster";
import PermissionMaster from "../permission/permissionMaster";
import VirtualTeamMaster from "../permission/virtualTeamMaster";
import RoleMaster from "../permission/roleMaster";
import UserPermissionMaster from "../permission/userPermissionMaster";
import UserRoleMaster from "../permission/userRoleMaster";
import NewStone from "../operations/newStone";
import UserWithoutPermission from "../report/userWithoutPermission";
import MixReportPurchaseMaster from "../mixDiamondSales/mixReportPurchaseMaster";
import MixReportSaleMaster from "../mixDiamondSales/mixReportSaleMaster";
import MixReportBucketTransaction from "../mixDiamondSales/mixReportBucketTransaction";
import InvoiceReport from "../report/invoiceReport";
import Proforma from "../sales/proforma";
import DepartmentGroupMaster from "../manufactureMaster/departmentGroupMaster";
import DepartmentMaster from "../manufactureMaster/departmentMaster";
import ProformaReport from "../report/proformaReport";
import LotIntimationMaster from "../manufacturing/operations/lotIntimationMaster";
import LotCreationMaster from "../manufacturing/operations/lotCreationMaster";
import KapanCreationMaster from "../manufacturing/operations/KapanCreationMaster";
import PendingLotReceive from "../manufactureMaster/pendingLotReceive";
import ChangeReceiveLocation from "../operations/changeReceiveLocationMaster";
import HoldStoneMaster from "../operations/holdStoneMaster";
import MixSellInvoice from "../mixDiamondSales/mixSellInvoice";
import MixSellProforma from "../mixDiamondSales/mixSellProforma";
import MixSalesProforma from "../mixDiamondSales/mixSalesProforma";
import CommisionReport from "../report/commisionReport";
import AboveMemoDays from "../report/aboveMemoDays";
import AbovePaymentDays from "../report/abovePaymentDays";
import MaxAllowedMemoAmount from "../report/maxAllowedMemoAmount";
import MaxMemoReminderPeriodDays from "../report/maxMemoReminderPeriodDays";
import AbovePaymentReminderDays from "../report/abovePaymentReminderDays";
import KapanSummary from "../report/kapanSummary";
import KapanHistoryDetail from '../manufactureMaster/kapanHistoryList'
import KapanList from '../manufactureMaster/kapanList'
import PacketIssueReceiveAssignMaster from "../manufactureMaster/packetIssueReceiveAssignMaster";
import RemarkMaster from "../manufactureMaster/remarkMaster";
import LossMaster from "../manufactureMaster/lossMaster";
import KapanLossTimeWiseReport from "../manufactureMaster/kapanLossTimeWiseReport";
import KapanLossListReport from "../manufactureMaster/kapanLossListReport";
import UserLossReport from "../manufactureMaster/userLossReport";
import ReprintBarcode from "../manufactureMaster/reprintBarcode";
import VideoUrl from "../manufactureMaster/videoUrl";
import NotFound from "../common/notFound";
import Watchlist from "../watchlist/watchlist";
import ChangePasswordModal from "../login/changePasswordModal";
import SellToOutsource from "../operations/sellToOutSource";
import RapnetLoginMaster from "../master/rapnetloginMaster";
import RapnetOperation from "../operations/rapnetOperation";
import GIAMaster from "../workermaster/giaMaster";
import UserProxy from "../../utility/proxy/manager/userProxy";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
// import Notification from "../notification/notification";
import { AiOutlineFileSearch } from "react-icons/ai";
import { FaArrowCircleDown, FaBarcode, FaBold, FaBook, FaBox, FaBoxOpen, FaBusinessTime, FaCalendar, FaCalendarAlt, FaCalendarCheck, FaCalendarDay, FaCartArrowDown, FaCheckSquare, FaClipboardList, FaCog, FaCut, FaEdit, FaExchangeAlt, FaEye, FaFileInvoice, FaFileInvoiceDollar, FaFlask, FaHistory, FaKey, FaLightbulb, FaListOl, FaLocationArrow, FaMoneyCheckAlt, FaPencilAlt, FaRegFolderOpen, FaRupeeSign, FaShapes, FaSprayCan, FaThumbsUp, FaTint, FaUnlock, FaUser, FaUserCheck, FaUserCog, FaUserEdit, FaUserShield, FaUserTie, FaUserTimes, FaUsers, FaVideo, FaWarehouse, FaRegEdit, FaLink } from "react-icons/fa";
import { BsBucketFill, BsMarkdownFill, BsPersonFill, BsSuitDiamond, BsSymmetryVertical } from "react-icons/bs";
import { TbCalendarDollar } from "react-icons/tb";
import { IoReceipt } from "react-icons/io5";
import { LuListChecks } from "react-icons/lu";
import { RiFileExcel2Fill, RiUserReceived2Fill } from "react-icons/ri";
import { IoBusinessSharp, IoColorPaletteSharp, IoDiamondOutline, IoDocumentText, IoEarthSharp, IoSend } from "react-icons/io5";
import { GiCardExchange, GiCutDiamond, GiDiamondTrophy, GiTakeMyMoney, GiMiner, GiMountainRoad, } from "react-icons/gi";
import { IoIosFlask, IoMdResize } from "react-icons/io";
import { BiArchive } from "react-icons/bi";
import { MdCancel, MdCleaningServices, MdLightMode, MdOutlineBallot, MdOutlineSignalWifiStatusbar4Bar, MdPayment, MdVerified, MdWbShade, MdOutlineQueryStats } from "react-icons/md";
import { SiBookstack } from "react-icons/si";
import { RiFolderReceivedFill, RiVipDiamondLine } from "react-icons/ri";
import { BiLoader, BiPurchaseTagAlt } from "react-icons/bi";
import { TbCertificate, TbPackage, TbStairsDown } from "react-icons/tb";
import { CgExtensionAdd, CgDollar } from "react-icons/cg";
import { LuShapes } from "react-icons/lu";
import { DocumentTypeMaster } from "../utilitymaster/documentTypeMaster";
import CancelSale from "../sales/cancelSale";
import Utility from "../../utility/utility";
import StoneSearchHistory from "../report/stoneSearchHistory";
import OfferTab from "../operations/offerTab";
import UserColumnPermissionMaster from "../permission/userColumnPermissionMaster";
import Revise from "../operations/revise";
import ColumnOrderSettingsMaster from "../settings/columnOrderSettingMaster";
import StockTallyMain from "../operations/stockTallyMain";
import { MdAddChart, MdTransferWithinAStation } from "react-icons/md";
import BoxMaster from "../genericmaster/boxMaster";
import ProformaAccount from "../report/proformaAccount";
import InvoiceAccount from "../report/invoiceAccount";
import StockTally from "../report/stocktally";
import NivodaCriteria from "../analysis/nivodaCriteria";
import Pricing from "../analysis/pricing";
import ColumnRoleMaster from "../permission/columnRoleMaster";
import UserColumnRoleMaster from "../permission/userColumnRoleMaster";
import StockExport from "../report/stockexport";
import ForceMediaTransfer from "../operations/forceMediaTransfer";
import ShapeMapping from "../analysis/shapeMapping";
import { BiTransferAlt } from "react-icons/bi";
import { BiSolidOffer } from "react-icons/bi";
import NivodaStock from "../analysis/nivodaStock";
import MemoReport from "../report/memoReport";
import { GoStack } from "react-icons/go";
import ManageCustomerProfile from "../login/manageCustomerProfile";
import ExcelUpload from "../analysis/excelUpload";
import ConsigneeMaster from "../analysis/consigneeMaster";
import MapConsigneeMaster from "../analysis/mapConsigneeMaster";
import ReassignCustomer from "../master/reassignCustomer";
import { MdOutlineTransferWithinAStation } from "react-icons/md";
import { BsGraphUpArrow } from "react-icons/bs";
import StonePotential from "../operations/stonePotential";
import PotentialSell from "../master/potentialSell";
import WolzaMarketSell from "../analysis/wolzaMarketSell";
import MixReportAvg from "../mixDiamondSales/mixReportAvg";
import ConsignmentReport from "../report/consignmentReport";
import { GiMaterialsScience, GiHammerBreak } from "react-icons/gi";
import StoneTypeMaster from "../genericmaster/stoneTypeMaster";
import NivodaUserMaster from "../analysis/nivodaUserMaster";
import RevertPrice from "../operations/revertPrice";
import UndoIcon from '@mui/icons-material/Undo';
import EditCustomerDetailsModal from "../login/editCustomerDetailsModal";
import CommonSnackbar from "../common/commonSnackBar";
import DnkInvoiceUpload from "../analysis/dnkInvoiceUpload";
import { FaFileUpload } from "react-icons/fa";
import MineMaster from "../tender/master/mineMaster";
import MixCommissionReport from "../mixDiamondSales/mixCommissionReport";
import MixProformaAccount from "../mixDiamondSales/mixProformaAccount";
import MixInvoiceAccount from "../mixDiamondSales/mixInvoiceAccount";
import Planning from "../manufacturing/operations/planning";
import { RiAuctionFill } from "react-icons/ri";
import CompanyMaster from "../tender/master/companyMaster";
import { BsBuildings } from "react-icons/bs";
import Tender from "../tender/operations/tender";
import TenderLot from "../tender/operations/tenderLot";
import LotPlanning from "../tender/operations/lotPlanning";
import Bid from "../tender/operations/bid";
import { GiThorHammer } from "react-icons/gi";
import { TbInvoice } from "react-icons/tb";
import { VscPreview, VscFileMedia } from "react-icons/vsc";
import BidPreview from "../tender/operations/bidPreview";
import StoneAsOnDate from "../report/stoneAsOnDate";
import TenderStats from "../tender/report/tenderStats";
import CancelMixSale from "../mixDiamondSales/cancelMixSale";
import CustomerWisePendingPayment from "../report/customerwisependingpayment";
import MixCustomerWisePendingPayment from "../mixDiamondSales/mixCustomerWisePendingPayment";
import KapanIssueReceiveMaster from "../manufactureMaster/kapanIssueReceiveMaster";
import DayWiseStoneSales from "../report/dayWiseStoneSales";
import DayWiseMixStoneSales from "../mixDiamondSales/dayWiseMixStoneSales";
import ConvertPacket from "../manufacturing/operations/convertPacket";
import TableIncMaster from "../genericmaster/tableIncMaster";
import SideIncMaster from "../genericmaster/sideIncMaster";
import { PiPicnicTable } from "react-icons/pi";
import { TbLayoutSidebarLeftExpand } from "react-icons/tb";
import MediaBuilder from "../stoneJourney/mediaBuilder";
import ApiDocs from "../../utility/documentation/apiDocs";
import NotificationNew from "../notification/notificationNew";
import TenderLotPlanning from "../tender/operations/tenderLotPlanning";
import ProcessMaster from "../manufactureMaster/processMaster";
import UserProcessMaster from "../manufactureMaster/userProcessMaster";
import { TbManualGearboxFilled } from "react-icons/tb";
import { FaClipboardUser } from "react-icons/fa6";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";

export class PageBody extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
      sidebarSize: 'sm',
      data: "",
      showChangePasswordModal: false,
      showEditProfileModal: false,
      showLoginUserDetail: false,
      showModal: false,
      modalText: "",
      modalVariant: "success",
      isXs: window.innerWidth < 576,// Bootstrap xs breakpoint
      errorSnackbar: false,
      errorMessage: "",
      snackbarVariant: "",
    };
    this.scrollToTop = this.scrollToTop.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.updateHtmlSidebarSize();
    this.getUserProfileDetails();
  }

  // Lifecycle method to update the attribute when the component updates
  componentDidUpdate() {
    this.updateHtmlSidebarSize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleResize = () => {
    this.setState({ isXs: window.innerWidth < 576 });
  };

  // Method to update the `data-sidebar-size` attribute on the `<html>` element
  updateHtmlSidebarSize = () => {
    const { sidebarSize } = this.state;
    document.documentElement.setAttribute('data-sidebar-size', sidebarSize);
  }

  // Method to toggle the sidebar size
  toggleSidebarSize = () => {
    if (!this.state.isXs) {
      this.setState(prevState => ({
        sidebarSize: prevState.sidebarSize === 'lg' ? 'sm' : 'lg'
      }));
    } else {
      this.setState(prevState => ({
        sidebarSize: 'lg'
      }));
      document.body.classList.add('vertical-sidebar-enable');
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  hideEditProfileModal = () => {
    this.setState({ showEditProfileModal: false })
    // setTimeout(() => setFetchData(true), 2000);
  };

  hideChangePasswordModal = () => {
    this.setState({ showChangePasswordModal: false })
  };
  handleScroll() {
    const scrollTop = window.pageYOffset;
    if (scrollTop > 100) {
      this.setState({ isVisible: true });
    } else {
      this.setState({ isVisible: false });
    }
  }

  getUserProfileDetails = () => {
    UserProxy.GetAllFieldsUserDetailByUserid(
      Constants.loggedInUser.id,
      (response) => {
        this.setState({ data: response });
      }
    );
  };

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };
  createOrUpdateCookies = (loggedInUser, userToken) => {
    let lliu = loggedInUser ? loggedInUser : Constants.loggedInUser;
    let lut = userToken ? userToken : Constants.userToken;

    let lExpires = Constants.COOKIE_EXPIRES();
    lliu.expires = lExpires;

    const { cookies } = this.props;
    cookies.remove("loggedInUser");
    cookies.remove("userToken");
    cookies.set("loggedInUser", JSON.stringify(lliu), {
      path: "/",
      expires: lExpires,
    }); // setting the cookie
    cookies.set("userToken", JSON.stringify(lut), {
      path: "/",
      expires: lExpires,
    }); // setting the cookie
  };

  onMenuChange = (menuSelection) => {
    this.createOrUpdateCookies();
  };

  hideChangePasswordModal = () => {
    this.setState({ showChangePasswordModal: false })
  };

  changePassword = (updatedUser) => {
    //Update existing User's password
    UserProxy.UpdatePassword(updatedUser, (updatedUser) => {
      if (updatedUser) {
        //Hidding change password modal after user password is changed
        this.hideChangePasswordModal();

        this.setState({
          showModal: true,
          modalText: "Password changed Successfully",
          modalVariant: "success"
        })
      } else {
        this.setState({
          showModal: true,
          modalText: "Password changed Failed, Maybe the old password is incorrect",
          modalVariant: "error",
        })
      }
    });
  };

  editUserAllDetails = (userData) => {

    UserProxy.UpdateUserAndProfileDetails([userData], (response) => {
      if (response) {
        this.setState({
          loadingButton: false,
          errorSnackbar: true,
          errorMessage: "Updated profile successfully !!",
          snackbarVariant: "success",
          showEditProfileModal: false,
        });
      } else {
        this.setState({
          loadingButton: false,
          errorSnackbar: true,
          errorMessage: Constants.APiFailErrorMessage,
          snackbarVariant: "error",
        });
      }
    });
  }

  handleValidation = (userData) => {
    //TODO do validation if needed here
    return true;
  };

  render() {

    const { isVisible } = this.state;
    const { isXs } = this.state;

    if (isXs) {
      document.body.classList.add('twocolumn-panel');
    } else {
      document.body.classList.remove('twocolumn-panel');
    }

    return (
      <div style={{ whiteSpace: "nowrap" }}>

        {/* Begin page */}
        <div id="layout-wrapper">
          <header id="page-topbar">
            <div className="layout-width">
              <div className="navbar-header" style={{ height: "50px", padding: "0 0.75rem" }}>
                <div className="d-flex">
                  <CommonSnackbar
                    show={this.state.errorSnackbar}
                    message={<Box>{this.state.errorMessage}</Box>}
                    variant={this.state.snackbarVariant}
                    autoHide={Constants.SnackBarCloseTimer}
                    handleClose={() => this.setState({ errorSnackbar: false })}
                    title={this.state.snackbarVariant === "error" ? "Error" :
                      this.state.snackbarVariant === "success" ? "Success" :
                        (this.state.snackbarVariant === "warning" ? "Warning" : "Failed")
                    }
                  />
                  <button
                    type="button"
                    className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none d-block d-sm-none"
                    id="topnav-hamburger-icon"
                    onClick={() => this.toggleSidebarSize()}
                  >
                    <span className="hamburger-icon">
                      <span />
                      <span />
                      <span />
                    </span>
                  </button>

                </div>
                <div className="d-flex align-items-center">
                  <div className="dropdown d-md-none topbar-head-dropdown header-item">
                    <button
                      type="button"
                      className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none"
                      id="page-header-search-dropdown"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="bx bx-search fs-22" />
                    </button>
                    <div
                      className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                      aria-labelledby="page-header-search-dropdown"
                    >
                      <form className="p-3">
                        <div className="form-group m-0">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search ..."
                              aria-label="Recipient's username"
                            />
                            <button className="btn btn-primary" type="submit">
                              <i className="mdi mdi-magnify" />
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>



                  {/* <div
              className="dropdown topbar-head-dropdown ms-1 header-item"
              id="notificationDropdown"
            >
              <button
                type="button"
                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none"
                id="page-header-notifications-dropdown"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="bx bx-bell fs-22" />
                <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                  3<span className="visually-hidden">unread messages</span>
                </span>
              </button>
              <div
                className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-notifications-dropdown"
              >
                <div className="dropdown-head bg-primary bg-pattern rounded-top">
                  <div className="p-3">
                    <div className="row align-items-center">
                      <div className="col">
                        <h6 className="m-0 fs-16 fw-semibold text-white">
                          {" "}
                          Notifications{" "}
                        </h6>
                      </div>
                      <div className="col-auto dropdown-tabs">
                        <span className="badge bg-light-subtle text-body fs-13">
                          {" "}
                          4 New
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="px-2 pt-2">
                    <ul
                      className="nav nav-tabs dropdown-tabs nav-tabs-custom"
                      data-dropdown-tabs="true"
                      id="notificationItemsTab"
                      role="tablist"
                    >
                      <li className="nav-item waves-effect waves-light">
                        <a
                          className="nav-link active"
                          data-bs-toggle="tab"
                          href="#all-noti-tab"
                          role="tab"
                          aria-selected="true"
                        >
                          All (4)
                        </a>
                      </li>
                      <li className="nav-item waves-effect waves-light">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#messages-tab"
                          role="tab"
                          aria-selected="false"
                        >
                          Messages
                        </a>
                      </li>
                      <li className="nav-item waves-effect waves-light">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#alerts-tab"
                          role="tab"
                          aria-selected="false"
                        >
                          Alerts
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="tab-content position-relative"
                  id="notificationItemsTabContent"
                >
                  <div
                    className="tab-pane fade show active py-2 ps-2"
                    id="all-noti-tab"
                    role="tabpanel"
                  >
                    <div
                      data-simplebar=""
                      style={{ maxHeight: 300 }}
                      className="pe-2"
                    >
                      <div className="text-reset notification-item d-block dropdown-item position-relative">
                        <div className="d-flex">
                          <div className="avatar-xs me-3 flex-shrink-0">
                            <span className="avatar-title bg-info-subtle text-info rounded-circle fs-16">
                              <i className="bx bx-badge-check" />
                            </span>
                          </div>
                          <div className="flex-grow-1">
                            <a href="#!" className="stretched-link">
                              <h6 className="mt-0 mb-2 lh-base">
                                Your <b>Elite</b> author Graphic Optimization{" "}
                                <span className="text-secondary">reward</span>{" "}
                                is ready!
                              </h6>
                            </a>
                            <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                              <span>
                                <i className="mdi mdi-clock-outline" /> Just 30
                                sec ago
                              </span>
                            </p>
                          </div>
                          <div className="px-2 fs-15">
                            <div className="form-check notification-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue=""
                                id="all-notification-check01"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="all-notification-check01"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-reset notification-item d-block dropdown-item position-relative">
                        <div className="d-flex">
                          <img
                            src="assets/images/users/avatar-2.jpg"
                            className="me-3 rounded-circle avatar-xs flex-shrink-0"
                            alt="user-pic"
                          />
                          <div className="flex-grow-1">
                            <a href="#!" className="stretched-link">
                              <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                Angela Bernier
                              </h6>
                            </a>
                            <div className="fs-13 text-muted">
                              <p className="mb-1">
                                Answered to your comment on the cash flow
                                forecast's graph 🔔.
                              </p>
                            </div>
                            <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                              <span>
                                <i className="mdi mdi-clock-outline" /> 48 min
                                ago
                              </span>
                            </p>
                          </div>
                          <div className="px-2 fs-15">
                            <div className="form-check notification-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue=""
                                id="all-notification-check02"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="all-notification-check02"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-reset notification-item d-block dropdown-item position-relative">
                        <div className="d-flex">
                          <div className="avatar-xs me-3 flex-shrink-0">
                            <span className="avatar-title bg-danger-subtle text-danger rounded-circle fs-16">
                              <i className="bx bx-message-square-dots" />
                            </span>
                          </div>
                          <div className="flex-grow-1">
                            <a href="#!" className="stretched-link">
                              <h6 className="mt-0 mb-2 fs-13 lh-base">
                                You have received{" "}
                                <b className="text-success">20</b> new messages
                                in the conversation
                              </h6>
                            </a>
                            <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                              <span>
                                <i className="mdi mdi-clock-outline" /> 2 hrs
                                ago
                              </span>
                            </p>
                          </div>
                          <div className="px-2 fs-15">
                            <div className="form-check notification-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue=""
                                id="all-notification-check03"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="all-notification-check03"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-reset notification-item d-block dropdown-item position-relative">
                        <div className="d-flex">
                          <img
                            src="assets/images/users/avatar-8.jpg"
                            className="me-3 rounded-circle avatar-xs flex-shrink-0"
                            alt="user-pic"
                          />
                          <div className="flex-grow-1">
                            <a href="#!" className="stretched-link">
                              <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                Maureen Gibson
                              </h6>
                            </a>
                            <div className="fs-13 text-muted">
                              <p className="mb-1">
                                We talked about a project on linkedin.
                              </p>
                            </div>
                            <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                              <span>
                                <i className="mdi mdi-clock-outline" /> 4 hrs
                                ago
                              </span>
                            </p>
                          </div>
                          <div className="px-2 fs-15">
                            <div className="form-check notification-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue=""
                                id="all-notification-check04"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="all-notification-check04"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="my-3 text-center view-all">
                        <button
                          type="button"
                          className="btn btn-soft-success waves-effect waves-light"
                        >
                          View All Notifications{" "}
                          <i className="ri-arrow-right-line align-middle" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade py-2 ps-2"
                    id="messages-tab"
                    role="tabpanel"
                    aria-labelledby="messages-tab"
                  >
                    <div
                      data-simplebar=""
                      style={{ maxHeight: 300 }}
                      className="pe-2"
                    >
                      <div className="text-reset notification-item d-block dropdown-item">
                        <div className="d-flex">
                          <img
                            src="assets/images/users/avatar-3.jpg"
                            className="me-3 rounded-circle avatar-xs"
                            alt="user-pic"
                          />
                          <div className="flex-grow-1">
                            <a href="#!" className="stretched-link">
                              <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                James Lemire
                              </h6>
                            </a>
                            <div className="fs-13 text-muted">
                              <p className="mb-1">
                                We talked about a project on linkedin.
                              </p>
                            </div>
                            <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                              <span>
                                <i className="mdi mdi-clock-outline" /> 30 min
                                ago
                              </span>
                            </p>
                          </div>
                          <div className="px-2 fs-15">
                            <div className="form-check notification-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue=""
                                id="messages-notification-check01"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="messages-notification-check01"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-reset notification-item d-block dropdown-item">
                        <div className="d-flex">
                          <img
                            src="assets/images/users/avatar-2.jpg"
                            className="me-3 rounded-circle avatar-xs"
                            alt="user-pic"
                          />
                          <div className="flex-grow-1">
                            <a href="#!" className="stretched-link">
                              <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                Angela Bernier
                              </h6>
                            </a>
                            <div className="fs-13 text-muted">
                              <p className="mb-1">
                                Answered to your comment on the cash flow
                                forecast's graph 🔔.
                              </p>
                            </div>
                            <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                              <span>
                                <i className="mdi mdi-clock-outline" /> 2 hrs
                                ago
                              </span>
                            </p>
                          </div>
                          <div className="px-2 fs-15">
                            <div className="form-check notification-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue=""
                                id="messages-notification-check02"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="messages-notification-check02"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-reset notification-item d-block dropdown-item">
                        <div className="d-flex">
                          <img
                            src="assets/images/users/avatar-6.jpg"
                            className="me-3 rounded-circle avatar-xs"
                            alt="user-pic"
                          />
                          <div className="flex-grow-1">
                            <a href="#!" className="stretched-link">
                              <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                Kenneth Brown
                              </h6>
                            </a>
                            <div className="fs-13 text-muted">
                              <p className="mb-1">
                                Mentionned you in his comment on 📃 invoice
                                #12501.
                              </p>
                            </div>
                            <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                              <span>
                                <i className="mdi mdi-clock-outline" /> 10 hrs
                                ago
                              </span>
                            </p>
                          </div>
                          <div className="px-2 fs-15">
                            <div className="form-check notification-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue=""
                                id="messages-notification-check03"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="messages-notification-check03"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-reset notification-item d-block dropdown-item">
                        <div className="d-flex">
                          <img
                            src="assets/images/users/avatar-8.jpg"
                            className="me-3 rounded-circle avatar-xs"
                            alt="user-pic"
                          />
                          <div className="flex-grow-1">
                            <a href="#!" className="stretched-link">
                              <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                Maureen Gibson
                              </h6>
                            </a>
                            <div className="fs-13 text-muted">
                              <p className="mb-1">
                                We talked about a project on linkedin.
                              </p>
                            </div>
                            <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                              <span>
                                <i className="mdi mdi-clock-outline" /> 3 days
                                ago
                              </span>
                            </p>
                          </div>
                          <div className="px-2 fs-15">
                            <div className="form-check notification-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue=""
                                id="messages-notification-check04"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="messages-notification-check04"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="my-3 text-center view-all">
                        <button
                          type="button"
                          className="btn btn-soft-success waves-effect waves-light"
                        >
                          View All Messages{" "}
                          <i className="ri-arrow-right-line align-middle" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade p-4"
                    id="alerts-tab"
                    role="tabpanel"
                    aria-labelledby="alerts-tab"
                  />
                  <div
                    className="notification-actions"
                    id="notification-actions"
                  >
                    <div className="d-flex text-muted justify-content-center">
                      Select{" "}
                      <div
                        id="select-content"
                        className="text-body fw-semibold px-1"
                      >
                        0
                      </div>{" "}
                      Result{" "}
                      <button
                        type="button"
                        className="btn btn-link link-danger p-0 ms-3"
                        data-bs-toggle="modal"
                        data-bs-target="#removeNotificationModal"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
                  <div><a href="/app/watchlist"><VisibilityOutlined /></a></div>

                  <div style={{ marginLeft: "1rem" }}><NotificationNew /></div>
                  {/* <div style={{ marginLeft: "1rem" }}><Notification /></div> */}
                  <div className="dropdown ms-sm-3 header-item topbar-user" style={{ height: "50px" }}>
                    <button
                      type="button"
                      className="btn shadow-none"
                      id="page-header-user-dropdown"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span className="d-flex align-items-center">
                        <Avatar
                          sx={{ width: 32, height: 32 }}
                          src={
                            this.state.data !== "" && this.state.data.photo
                              ? `data:image/png;base64, ${this.state.data.photo}`
                              : ""
                          }
                        >
                          {Constants.loggedInUser.username
                            .substring(0, 1)
                            .toUpperCase()}
                        </Avatar>
                        <span className="text-start ms-xl-2">
                          <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                            {Constants.loggedInUser.username}
                          </span>
                          <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                            User
                          </span>
                        </span>
                      </span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-end">
                      {/* item*/}
                      <h6 className="dropdown-header">Welcome {Constants.loggedInUser.username}!</h6>

                      <a className="dropdown-item" href="#s" onClick={(e) => {
                        this.setState({ showEditProfileModal: true, showLoginUserDetail: false })
                      }}>
                        <i className="mdi mdi-account-edit text-muted fs-16 align-middle me-1" />{" "}
                        <span className="align-middle">
                          Profile
                        </span>
                      </a>

                      {Constants.loggedInUser.usertype === "E" ?
                        <a className="dropdown-item"
                          href="/app/managecustomerprofile"
                          onClick={() => window.location.href = '/managecustomerprofile'}>
                          <i className="mdi mdi-account-multiple text-muted fs-16 align-middle me-1" />{" "}
                          <span className="align-middle">
                            Manage Customer Profile
                          </span>
                        </a>
                        : null}

                      <a className="dropdown-item" href="#s" onClick={() => {
                        this.setState({ showChangePasswordModal: true, showLoginUserDetail: false });
                      }}>
                        <i className="mdi mdi-lock-open text-muted fs-16 align-middle me-1" />{" "}
                        <span className="align-middle" data-key="t-logout">
                          Change Password
                        </span>
                      </a>

                      <a className="dropdown-item" href="#s" onClick={this.props.onLogout}>
                        <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />{" "}
                        <span className="align-middle" data-key="t-logout">
                          Logout
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
          {/* removeNotificationModal */}

          {/* /.modal */}
          {/* ========== App Menu ========== */}
          <div className="app-menu navbar-menu" onMouseOver={() => this.toggleSidebarSize()} onMouseOut={() => this.toggleSidebarSize()}>
            {/* LOGO */}
            <div className="navbar-brand-box">

              {/* Light Logo*/}
              <a href="/app/dashboard" className="logo logo-light">
                <span className="logo-sm">
                  <img src="/favicon-32x32.png" alt="" height={22} />
                </span>
                <span className="logo-lg">
                  <img src="/pansuriyaMainLogo.png" alt="" height={50} />
                </span>
              </a>
              <button
                type="button"
                className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                id="vertical-hover"
              >
                <i className="ri-record-circle-line" />
              </button>
            </div>
            <div id="" style={{ overflowY: 'auto', height: '100%' }}>
              <div className="container-fluid">
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <li className="menu-title">
                    <span data-key="t-menu">Menu</span>
                  </li>

                  {/* Master */}
                  <li className="nav-item">
                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_STOCK ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_EMPLOYEE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_BROKER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_CUSTOMER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_REASSIGNCUSTOMER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_LAB ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_TRADINGCOMPANY ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_RAPNET_LOGINS
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#sidebarDashboards"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarDashboards"
                      >
                        <i className="mdi mdi-crown" />
                        <span data-key="t-dashboards">Master</span>
                      </a>
                    ) : null}

                    <div className="collapse menu-dropdown" id="sidebarDashboards">
                      <ul className="nav nav-sm flex-column" style={{ display: 'flex' }}>

                        {/* USER */}
                        <Link to="master/user" style={{ textDecoration: "none", marginBottom: "10px" }}>
                          <span
                            style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                            onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                            onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                          >
                            &nbsp;&nbsp;<FaUser size={14} />
                            &nbsp;&nbsp;&nbsp;&nbsp;User
                          </span>
                        </Link>

                        {/* EMPLOYEE */}
                        {(Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_EMPLOYEE) || Constants.loggedInUser.usertype === "E") && (
                          <Link to="master/employee" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaUserTie size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Employee
                            </span>
                          </Link>
                        )}

                        {/* BROKER */}
                        {(Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_BROKER) || ["B", "E"].includes(Constants.loggedInUser.usertype)) && (
                          <Link to="master/broker" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaBold size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Broker
                            </span>
                          </Link>
                        )}

                        {/* CUSTOMER */}
                        {(Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_CUSTOMER) || ["C", "E"].includes(Constants.loggedInUser.usertype)) && (
                          <Link to="master/customer" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<BsPersonFill size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Customer
                            </span>
                          </Link>
                        )}

                        {/* RE-ASSIGN CUSTOMER */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_REASSIGNCUSTOMER) && (
                          <Link to="master/reassigncustomer" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<MdOutlineTransferWithinAStation size={16} />
                              &nbsp;&nbsp;&nbsp;Reassign Customer
                            </span>
                          </Link>
                        )}

                        {/* POTENTIAL - SELL */}
                        {Constants.loggedInUser.usertype === "E" && (
                          <Link to="master/potentialsell" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<IoDiamondOutline size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Potential Sell
                            </span>
                          </Link>
                        )}

                        {/* LAB */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_LAB) && (
                          <Link to="master/lab" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaFlask size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Lab
                            </span>
                          </Link>
                        )}

                        {/* TRADING COMPANY */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_TRADINGCOMPANY) && (
                          <Link to="master/tradingcompany" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<IoBusinessSharp size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Trading Company
                            </span>
                          </Link>
                        )}

                        {/* RAPNET LOGINS */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_RAPNET_LOGINS) && (
                          <Link to="master/rapnetlogins" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaUserShield size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Rapnet Logins
                            </span>
                          </Link>
                        )}
                      </ul>
                    </div>
                  </li>

                  {/* Operations */}
                  <li className="nav-item">
                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_STOCK ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_SELL_TO_OUTSOURCE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_RAPNET_UPLOAD ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_RAPNET_EDIT_REMOVE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_RAPNET_AFFECTED_STONE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_NEWTEST ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_LABTESTINGSUMMARY ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_LABTESTING ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_REPORTRECEIVED ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_STONERECEIVED ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_APPROVEREJECT ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_PRICING ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_PRICINGAPPROVAL ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_TAGGING ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_AVAILABLE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_RECHECK ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_RECHECKDONE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_MEMO ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_MEMO_ISSUE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_MEMO_RETURNMANAGE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_MEMO_SELL ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_MEMO_SEND ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_MEMORECEIVE ||
                        (iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_NEWSTONE &&
                          iPermission.type === "ADD") ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_CHANGELOCATION_CHANGELOCATION ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_CHANGELOCATION_RECEIVELOCATION ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_STONEHOLD_HOLD ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_MEDIA_TRANSFER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_STONEPOTENTIAL ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_REVERT_PRICE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_STOCKTALLY
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#sidebarOperations"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarOperations"
                      >
                        <i className="mdi mdi-wrench" />
                        <span data-key="t-dashboards">Operations</span>
                      </a>
                    ) : null}

                    <div className="collapse menu-dropdown" id="sidebarOperations">

                      <ul className="nav nav-sm flex-column">
                        {/* STOCK */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_STOCK) && (
                          <Link to="operation/stock" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaWarehouse size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Stock
                            </span>
                          </Link>
                        )}

                        {/* SELL TO OUTSOURCE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_SELL_TO_OUTSOURCE) && (
                          <Link to="operation/selloutsource" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaCartArrowDown size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Sell to Outsource
                            </span>
                          </Link>
                        )}

                        {/* RAPNET*/}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_RAPNET_UPLOAD ||
                          iPermission.permissionid === Constants.PERMISSIONS.OPERATION_RAPNET_EDIT_REMOVE ||
                          iPermission.permissionid === Constants.PERMISSIONS.OPERATION_RAPNET_AFFECTED_STONE) && (
                            <Link to="operation/rapnetoperation" style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaListOl size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Rapnet
                              </span>
                            </Link>
                          )}

                        {/* LAB TEST*/}
                        {Constants.USER_PERMISSION.some((iPermission) =>
                          iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_LAB_NEWTEST ||
                          iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_LAB_LABTESTINGSUMMARY ||
                          iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_LAB_LABTESTING ||
                          iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_LAB_REPORTRECEIVED ||
                          iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_LAB_STONERECEIVED ||
                          iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_LAB_APPROVEREJECT ||
                          iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_LAB_PRICING ||
                          iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_LAB_PRICINGAPPROVAL ||
                          iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_LAB_TAGGING ||
                          iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_LAB_AVAILABLE) && (
                            <Link to="operation/labtest" style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<IoIosFlask size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Lab Test
                              </span>
                            </Link>
                          )}

                        {/* RE-CHECK*/}
                        {/* {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_LAB_RECHECK ||
                          iPermission.permissionid === Constants.PERMISSIONS.OPERATION_LAB_RECHECKDONE) && (
                            <Link to="operation/recheck" style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaListOl size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Re-Check
                              </span>
                            </Link>
                          )} */}

                        {/* MEMO */}
                        <Link to="operation/memo" style={{ textDecoration: "none", marginBottom: "10px" }}>
                          <span
                            style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                            onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                            onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                          >
                            &nbsp;&nbsp;<SiBookstack size={14} />
                            &nbsp;&nbsp;&nbsp;&nbsp;Memo
                          </span>
                        </Link>

                        {/* NEW STONE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid ===
                          Constants.PERMISSIONS.OPERATION_NEWSTONE && iPermission.type === "ADD")
                          && (
                            <Link to="operation/newstone" style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<RiVipDiamondLine size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;New Stone
                              </span>
                            </Link>
                          )}

                        {/* HOLD STONE */}
                        {Constants.loggedInUser.usertype !== "B"
                          && (
                            <Link to="operation/holdstones" style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaBoxOpen size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Hold Stones
                              </span>
                            </Link>
                          )}

                        {/* OFFER */}
                        <Link to="operation/offer" style={{ textDecoration: "none", marginBottom: "10px" }}>
                          <span
                            style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                            onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                            onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                          >
                            &nbsp;&nbsp;<BiSolidOffer size={14} />
                            &nbsp;&nbsp;&nbsp;&nbsp;Offer
                          </span>
                        </Link>

                        {/* REVISE*/}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_REVISE_STOCK ||
                          iPermission.permissionid === Constants.PERMISSIONS.OPERATION_REVISE_AVERAGE) && (
                            <Link to="operation/revise" style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaRegEdit size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Revise
                              </span>
                            </Link>
                          )}

                        {/* STOCK TALLY*/}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_STOCKTALLY) && (
                          <Link to="operation/stocktally" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<MdAddChart size={16} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Stock Tally
                            </span>
                          </Link>
                        )}

                        {/*FORCE MEDIA TRANSFER */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_MEDIA_TRANSFER) && (
                          <Link to="operation/mediatransfer" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<BiTransferAlt size={16} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Force Media Transfer
                            </span>
                          </Link>
                        )}

                        {/* STONE POTENTIAL */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_STONEPOTENTIAL) && (
                          <Link to="operation/stonepotential" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<BsGraphUpArrow size={16} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Stone Potential
                            </span>
                          </Link>
                        )}

                        {/* LINK */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_REVERT_PRICE) && (
                          <Link to="operation/revertprice" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<UndoIcon size={16} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Revert Price
                            </span>
                          </Link>
                        )}
                      </ul>
                    </div>
                  </li>

                  {/* Mix Diamond */}
                  <li className="nav-item">

                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_VIEW_STOCK ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_REPORT_PURCHASE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_REPORT_SALES ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_REPORT_BUCKETTRANSACTION ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_REPORT_MIXAVG ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_BUCKET ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_REPORT_COMMISSION_COMMISSION ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_REPORT_CUSTOMER_WISE_PENDING_PAYMENT ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_REPORT_DAY_WISE_STONE_SALES ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_REPORT_ACCOUNT_INVOICE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_REPORT_ACCOUNT_PROFORMA ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_SHAPE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_SIZE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_CLARITY ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_COLOR ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_PURCHASE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_SALE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MIX_SALES_CANCEL_SALE
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#sidebarApps"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarApps"
                      >
                        <i className="mdi mdi-diamond" />
                        <span data-key="t-apps">Mix Diamond</span>
                      </a>
                    ) : null}

                    <div className="collapse menu-dropdown" id="sidebarApps">
                      <ul className="nav nav-sm flex-column">
                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_SHAPE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_SIZE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_CLARITY ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_COLOR
                          ) !== undefined ? (
                            <a
                              href="#mixDiamondMaster"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="mixDiamondMaster"
                              data-key="t-calender"
                            >
                              Masters
                            </a>
                          ) : null}

                          <div
                            className="collapse menu-dropdown"
                            id="mixDiamondMaster"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* SHAPE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_SHAPE) && (
                                <Link to='mixdiamond/master/shape' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaShapes size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Shape
                                  </span>
                                </Link>
                              )}

                              {/* SIZE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_SIZE) && (
                                <Link to='mixdiamond/master/size' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<IoMdResize size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Size
                                  </span>
                                </Link>
                              )}

                              {/* CLARITY */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_CLARITY) && (
                                <Link to='mixdiamond/master/clarity' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<MdCleaningServices size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Clarity
                                  </span>
                                </Link>
                              )}

                              {/* COLOR */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_COLOR) && (
                                <Link to='mixdiamond/master/color' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<IoColorPaletteSharp size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Color
                                  </span>
                                </Link>
                              )}

                            </ul>
                          </div>
                        </li>

                        {/* BUCKET */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_BUCKET) && (
                          <Link to='mixdiamond/bucket' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<BsBucketFill size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Bucket
                            </span>
                          </Link>
                        )}

                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_PURCHASE ||
                              iPermission.permissionid === Constants.PERMISSIONS.MIX_SALE
                          ) !== undefined ? (
                            <a
                              href="#sidebarEmail"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="sidebarEmail"
                              data-key="t-email"
                            >
                              Operations
                            </a>
                          ) : null}

                          <div className="collapse menu-dropdown" id="sidebarEmail">
                            <ul className="nav nav-sm flex-column">

                              {/* MIX_PURCHASE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_PURCHASE) && (
                                <Link to='mixdiamond/operation/purchase' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<BiPurchaseTagAlt size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Purchase
                                  </span>
                                </Link>
                              )}

                              {/* MIX_SALE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_SALE) && (
                                <Link to='mixdiamond/operation/sales' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaRupeeSign size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Sales
                                  </span>
                                </Link>
                              )}

                            </ul>
                          </div>
                        </li>

                        {/* MIX - PROFORMA */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_BUCKET) && (
                          <Link to='mixdiamond/proforma' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaFileInvoice size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Proforma
                            </span>
                          </Link>
                        )}

                        {/* MIX - CANCEL_SALE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_SALES_CANCEL_SALE) && (
                          <Link to='mixdiamond/cancelsale' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<MdCancel size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Cancel Sale
                            </span>
                          </Link>
                        )}

                        <li className="nav-item">

                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_VIEW_STOCK ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_REPORT_PURCHASE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_REPORT_SALES ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_REPORT_BUCKETTRANSACTION ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_REPORT_MIXAVG ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_BUCKET ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_REPORT_COMMISSION_COMMISSION ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_REPORT_CUSTOMER_WISE_PENDING_PAYMENT ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_REPORT_DAY_WISE_STONE_SALES ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_REPORT_ACCOUNT_INVOICE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MIX_REPORT_ACCOUNT_PROFORMA
                          ) !== undefined ? (
                            <a
                              href="#sidebarEcommerce"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="sidebarEcommerce"
                              data-key="t-ecommerce"
                            >
                              Report
                            </a>
                          ) : null}

                          <div
                            className="collapse menu-dropdown"
                            id="sidebarEcommerce"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* MIX - VIEW_STOCK */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_VIEW_STOCK) && (
                                <Link to='mixdiamond/report/viewstock' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaBox size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;View Stock
                                  </span>
                                </Link>
                              )}

                              {/* MIX - REPORT_PURCHASE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_PURCHASE) && (
                                <Link to='mixdiamond/report/purchase' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<BiPurchaseTagAlt size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Purchase
                                  </span>
                                </Link>
                              )}

                              {/* MIX - REPORT_SALES */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_SALES) && (
                                <Link to='mixdiamond/report/sales' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaRupeeSign size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Sales
                                  </span>
                                </Link>
                              )}

                              {/* MIX - BUCKET_TRANSACTION */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_BUCKETTRANSACTION) && (
                                <Link to='mixdiamond/report/buckettransaction' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<BsBucketFill size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Bucket Transactions
                                  </span>
                                </Link>
                              )}

                              {/* MIX - MIXAVG */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_MIXAVG) && (
                                <Link to='mixdiamond/report/mixavg' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<BsBucketFill size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Mix Avg
                                  </span>
                                </Link>
                              )}

                              {/* MIX - INVOICE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_BUCKET) && (
                                <Link to='mixdiamond/report/mixinvoice' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaFileInvoiceDollar size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Mix Invoice
                                  </span>
                                </Link>
                              )}

                              {/* MIX - PROFORMA */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_BUCKET) && (
                                <Link to='mixdiamond/report/mixproforma' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaFileInvoice size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Mix Proforma
                                  </span>
                                </Link>
                              )}

                              {/* MIX - COMMISSION */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_COMMISSION_COMMISSION ||
                                iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_COMMISSION_PAYMENT ||
                                iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_COMMISSION_HISTORY) && (
                                  <Link to='mixdiamond/report/mixcommission' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<FaFileInvoice size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Mix Commission
                                    </span>
                                  </Link>
                                )}

                              {/* MIX - CUSTOMER WISE PENDINGPAYMENT */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_CUSTOMER_WISE_PENDING_PAYMENT) && (
                                <Link to='mixdiamond/report/customerwisependingpayment' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaFileInvoice size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Customer Wise Pending Payment
                                  </span>
                                </Link>
                              )}

                              {/* MIX - DAY WISE STONE SALES */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_DAY_WISE_STONE_SALES) && (
                                <Link to='mixdiamond/report/daywisemixstonesales' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaFileInvoice size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Day Wise Mix Stone Sales
                                  </span>
                                </Link>
                              )}

                              {/* <div className="collapse menu-dropdown" id="sidebarApps"> */}
                              {/* <ul className="nav nav-sm flex-column"> */}
                              <li className="nav-item">
                                {Constants.USER_PERMISSION.find(
                                  (iPermission) =>
                                    iPermission.permissionid ===
                                    Constants.PERMISSIONS.MIX_REPORT_ACCOUNT_INVOICE ||
                                    iPermission.permissionid ===
                                    Constants.PERMISSIONS.MIX_REPORT_ACCOUNT_PROFORMA
                                ) !== undefined ? (
                                  <a
                                    href="#ReportUserAccount"
                                    className="nav-link"
                                    data-bs-toggle="collapse"
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls="ReportUserAccount"
                                    data-key="t-calender"
                                  >
                                    Accounts
                                  </a>
                                ) : null}
                                <div
                                  className="collapse menu-dropdown"
                                  id="ReportUserAccount"
                                >
                                  <ul className="nav nav-sm flex-column">

                                    {/* MIX - ACCOUNT PROFORMA */}
                                    {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_ACCOUNT_PROFORMA) && (
                                      <Link to='mixdiamond/report/account/mixproforma' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                        <span
                                          style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                          onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                          onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                        >
                                          &nbsp;&nbsp;<FaFileInvoice size={14} />
                                          &nbsp;&nbsp;&nbsp;&nbsp;Proforma
                                        </span>
                                      </Link>
                                    )}

                                    {/* MIX - ACCOUNT INVOICE */}
                                    {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_ACCOUNT_INVOICE) && (
                                      <Link to='mixdiamond/report/account/mixinvoice' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                        <span
                                          style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                          onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                          onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                        >
                                          &nbsp;&nbsp;<FaFileInvoiceDollar size={14} />
                                          &nbsp;&nbsp;&nbsp;&nbsp;Invoice
                                        </span>
                                      </Link>
                                    )}

                                  </ul>
                                </div>
                              </li>
                              {/* </ul> */}
                              {/* </div> */}
                            </ul>
                          </div>
                        </li>

                      </ul>
                    </div>
                  </li>

                  {/* Generic Master */}
                  <li className="nav-item">
                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_EYECLEAN ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_INCLUSION ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_LUSTER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_TINGE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_HNA ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_OPEN ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_MILKY ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_SHADE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_KEYTOSYMBOL ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_BUISNESSTYPE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_QUALITY ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_EXCHANGERATE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_SIZE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_CUT ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_FLO ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_SHAPE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_POL ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_COLOR ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_FANCY_COLOR ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_CLARITY ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_SYM ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_CUTPOLSYM ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_BOX ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_STONETYPE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_TABLEINC ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_SIDEINC ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_CLULET
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#GenericMasterDash"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="GenericMasterDash"
                      >
                        <i className="mdi mdi-crown" />
                        <span data-key="t-dashboards">Generic Master</span>
                      </a>
                    ) : null}

                    <div className="collapse menu-dropdown" id="GenericMasterDash">
                      <ul className="nav nav-sm flex-column">

                        {/* EYECLEAN */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_EYECLEAN) && (
                          <Link to='generic-master/eyeclean' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaEye size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Eyeclean
                            </span>
                          </Link>
                        )}

                        {/* INCLUSION */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_INCLUSION) && (
                          <Link to='generic-master/inclusion' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaArrowCircleDown size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Inclusion
                            </span>
                          </Link>
                        )}

                        {/* LUSTER */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_LUSTER) && (
                          <Link to='generic-master/luster' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaLightbulb size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Luster
                            </span>
                          </Link>
                        )}

                        {/* TINGE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_TINGE) && (
                          <Link to='generic-master/tinge' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaTint size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Tinge
                            </span>
                          </Link>
                        )}

                        {/* HNA */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_HNA) && (
                          <Link to='generic-master/hna' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<BsSuitDiamond size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;HNA
                            </span>
                          </Link>
                        )}

                        {/* OPEN */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_OPEN) && (
                          <Link to='generic-master/open' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaUnlock size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Open
                            </span>
                          </Link>
                        )}

                        {/* MILKY */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_MILKY) && (
                          <Link to='generic-master/milky' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<BsMarkdownFill size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Milky
                            </span>
                          </Link>
                        )}

                        {/* CULET */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_CLULET) && (
                          <Link to="/generic-master/culet" style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<GiDiamondTrophy size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Culet
                            </span>
                          </Link>
                        )}

                        {/* SHADE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_SHADE) && (
                          <Link to='generic-master/shade' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<MdWbShade size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Shade
                            </span>
                          </Link>
                        )}

                        {/* KEYTOSYMBOL */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_KEYTOSYMBOL) && (
                          <Link to='generic-master/keytosymbol' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaKey size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Key to Symbol
                            </span>
                          </Link>
                        )}

                        {/* BUISNESSTYPE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_BUISNESSTYPE) && (
                          <Link to='generic-master/businesstype' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaBusinessTime size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Business type
                            </span>
                          </Link>
                        )}

                        {/* QUALITY */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_QUALITY) && (
                          <Link to='generic-master/quality' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaThumbsUp size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Quality
                            </span>
                          </Link>
                        )}

                        {/* EXCHANGERATE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_EXCHANGERATE) && (
                          <Link to='generic-master/exchangerate' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaExchangeAlt size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Exchange Rate
                            </span>
                          </Link>
                        )}

                        {/* SIZE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_SIZE) && (
                          <Link to='generic-master/size' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<IoMdResize size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Size
                            </span>
                          </Link>
                        )}

                        {/* CUT */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_CUT) && (
                          <Link to='generic-master/cut' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaCut size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Cut
                            </span>
                          </Link>
                        )}

                        {/* FLO */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_FLO) && (
                          <Link to='generic-master/fluoresence' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<MdLightMode size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Fluorescence
                            </span>
                          </Link>
                        )}

                        {/* SHAPE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_SHAPE) && (
                          <Link to='generic-master/shape' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaShapes size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Shape
                            </span>
                          </Link>
                        )}

                        {/* POL */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_POL) && (
                          <Link to='generic-master/polish' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaSprayCan size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Polish
                            </span>
                          </Link>
                        )}

                        {/* COLOR */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_COLOR) && (
                          <Link to='generic-master/color' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<IoColorPaletteSharp size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Color
                            </span>
                          </Link>
                        )}

                        {/* FANCY_COLOR */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_FANCY_COLOR) && (
                          <Link to='generic-master/fancycolor' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<IoColorPaletteSharp size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Fancy Color
                            </span>
                          </Link>
                        )}

                        {/* CLARITY */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_CLARITY) && (
                          <Link to='generic-master/clarity' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<MdCleaningServices size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Clarity
                            </span>
                          </Link>
                        )}

                        {/* SYM */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_SYM) && (
                          <Link to='generic-master/symmetry' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<BsSymmetryVertical size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Symmetry
                            </span>
                          </Link>
                        )}

                        {/* CUTPOLSYM */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_CUTPOLSYM) && (
                          <Link to='generic-master/cutpolsym' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<GiCutDiamond size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Cutpolsym
                            </span>
                          </Link>
                        )}

                        {/* BOX */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_BOX) && (
                          <Link to='generic-master/box' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<BiArchive size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Box
                            </span>
                          </Link>
                        )}

                        {/* STONETYPE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_STONETYPE) && (
                          <Link to='generic-master/stonetype' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<GiMaterialsScience size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Stone Type
                            </span>
                          </Link>
                        )}

                        {/* TABLEINC */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_TABLEINC) && (
                          <Link to='generic-master/tableinc' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<PiPicnicTable size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Table Inc
                            </span>
                          </Link>
                        )}

                        {/* SIDEINC */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MASTER_SIDEINC) && (
                          <Link to='generic-master/sideinc' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<TbLayoutSidebarLeftExpand size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Side Inc
                            </span>
                          </Link>
                        )}

                      </ul>
                    </div>
                  </li>

                  {/* Manufacturing */}
                  <li className="nav-item">
                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_MASTER_DEPARTMENTGROUP ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_MASTER_DEPARTMENT ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_MASTER_REMARK ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_MASTER_LOSS ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOTINTIMATION ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOTCREATION ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_KAPANCREATION ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEIPT ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEPT_RECEIPT ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETISSUE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETRECEIVE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETASSIGN ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_REPRINTBARCODE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_ADDVIDEOURL ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_CONVERTTOSTONE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_CONVERTTOBUCKET ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_REPORT_PENDINGLOTRECEIVE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_REPORT_KAPANLIST ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_REPORT_KAPANHISTORYDETAIL ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_USER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_KAPANLOSSTIMEWISE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_KAPANLOSS ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_USER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_KAPANLOSSTIMEWISE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_KAPANLOSS ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_PRICEPLANNING ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOCKEDPLANNING ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_PRICEPLANNING_MARKER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOCKEDPLANNING_MARKER
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#sidebarmanufacturing"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarmanufacturing"
                      >
                        <i className="mdi mdi-factory" />
                        <span data-key="t-apps">Manufacturing</span>
                      </a>
                    ) : null}
                    <div className="collapse menu-dropdown" id="sidebarmanufacturing">
                      <ul className="nav nav-sm flex-column">
                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_MASTER_DEPARTMENTGROUP ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_MASTER_DEPARTMENT ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_MASTER_REMARK ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_MASTER_LOSS
                          ) !== undefined ? (
                            <a
                              href="#MfgMaster"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="MfgMaster"
                              data-key="t-calender"
                            >
                              Masters
                            </a>
                          ) : null}

                          <div
                            className="collapse menu-dropdown"
                            id="MfgMaster"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* DEPARTMENTGROUP */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_MASTER_DEPARTMENTGROUP) && (
                                <Link to='manufacturing/master/departmentgroup' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<HiOutlineBuildingOffice2 size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Department Group
                                  </span>
                                </Link>
                              )}

                              {/* DEPARTMENT */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_MASTER_DEPARTMENT) && (
                                <Link to='manufacturing/master/department' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<HiOutlineBuildingOffice size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Department
                                  </span>
                                </Link>
                              )}

                              {/* PROCESS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_MASTER_PROCESS) && (
                                <Link to='manufacturing/master/process' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<TbManualGearboxFilled size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Process
                                  </span>
                                </Link>
                              )}

                              {/*USER PROCESS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_MASTER_USERPROCESS) && (
                                <Link to='manufacturing/master/userprocess' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaClipboardUser size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;User Process
                                  </span>
                                </Link>
                              )}

                              {/* REMARK */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_MASTER_REMARK) && (
                                <Link to='manufacturing/master/remarkcategory' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaPencilAlt size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Remark Category
                                  </span>
                                </Link>
                              )}

                              {/* LOSS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_MASTER_LOSS) && (
                                <Link to='manufacturing/master/losscategory' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<TbStairsDown size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Loss Category
                                  </span>
                                </Link>
                              )}

                            </ul>
                          </div>
                        </li>
                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOTINTIMATION ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOTCREATION ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_KAPANCREATION ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEIPT ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEPT_RECEIPT ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETISSUE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETRECEIVE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETASSIGN ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_REPRINTBARCODE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_ADDVIDEOURL ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_CONVERTTOSTONE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_CONVERTTOBUCKET ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_PRICEPLANNING ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOCKEDPLANNING
                          ) !== undefined ? (
                            <a
                              href="#OperatiojnSidebar"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="OperatiojnSidebar"
                              data-key="t-calender"
                            >
                              Operations
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="OperatiojnSidebar"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* LOTINTIMATION */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOTINTIMATION) && (
                                <Link to='manufacturing/operation/lotintimation' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<TbPackage size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Lot Intimation
                                  </span>
                                </Link>
                              )}

                              {/* LOTCREATION */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOTCREATION) && (
                                <Link to='manufacturing/operation/lotcreation' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<CgExtensionAdd size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Lot Creation
                                  </span>
                                </Link>
                              )}

                              {/* KAPANCREATION */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_KAPANCREATION) && (
                                <Link to='manufacturing/operation/kapancreation' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<GiHammerBreak size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Kapan Creation
                                  </span>
                                </Link>
                              )}

                              {/* KAPAN ISSUE/RECEIVE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEIPT ||
                                iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_ISSUERECEPT_RECEIPT) && (
                                  <Link to='manufacturing/operation/kapan-issuereceive' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<FaClipboardList size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Kapan Issue/Receive
                                    </span>
                                  </Link>
                                )}

                              {/* PACKET ISSUE/RECEIVE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETISSUE ||
                                iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETRECEIVE ||
                                iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETASSIGN) && (
                                  <Link to='manufacturing/operation/packet-issuereceive' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<FaClipboardList size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Packet Issue/Receive
                                    </span>
                                  </Link>
                                )}

                              {/* REPRINTBARCODE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_REPRINTBARCODE) && (
                                <Link to='manufacturing/operation/reprintbarcode' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaBarcode size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Reprint Barcode
                                  </span>
                                </Link>
                              )}

                              {/* ADDVIDEOURL */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_ADDVIDEOURL) && (
                                <Link to='manufacturing/operation/videourl' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaVideo size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Add Video Url
                                  </span>
                                </Link>
                              )}

                              {/* CONVERT_PACKET */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_CONVERTTOSTONE ||
                                iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_CONVERTTOBUCKET) && (
                                  <Link to='manufacturing/operation/convertpacket' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<GiCardExchange size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Convert Packet
                                    </span>
                                  </Link>
                                )}

                              {/* PRICEPLANNING */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_PRICEPLANNING ||
                                iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOCKEDPLANNING) && (
                                  <Link to='manufacturing/operation/priceplanning' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<TbCalendarDollar size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Price Planning
                                    </span>
                                  </Link>
                                )}

                            </ul>
                          </div>
                        </li>
                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_REPORT_PENDINGLOTRECEIVE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_REPORT_KAPANLIST ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_REPORT_KAPANHISTORYDETAIL ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_USER ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_KAPANLOSSTIMEWISE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_KAPANLOSS
                          ) !== undefined ? (
                            <a
                              href="#ReportSidebar"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="ReportSidebar"
                              data-key="t-calender"
                            >
                              Report
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="ReportSidebar"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* PENDINGLOTRECEIVE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_REPORT_PENDINGLOTRECEIVE) && (
                                <Link to='manufacturing/report/pendinglotreceive' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<MdOutlineBallot size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Pending Lot Receive
                                  </span>
                                </Link>
                              )}

                              {/* KAPANLIST */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_REPORT_KAPANLIST) && (
                                <Link to='manufacturing/report/kapan' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaClipboardList size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Kapan
                                  </span>
                                </Link>
                              )}

                              {/* KAPANHISTORYDETAIL */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_REPORT_KAPANHISTORYDETAIL) && (
                                <Link to='manufacturing/report/kapanhistory' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaHistory size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Kapan History
                                  </span>
                                </Link>
                              )}

                              <li className="nav-item">
                                {Constants.USER_PERMISSION.find(
                                  (iPermission) =>
                                    iPermission.permissionid ===
                                    Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_USER ||
                                    iPermission.permissionid ===
                                    Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_KAPANLOSSTIMEWISE ||
                                    iPermission.permissionid ===
                                    Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_KAPANLOSS
                                ) !== undefined ? (
                                  <a href="#sidebarCrm" className="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarCrm" data-key="t-level-2.2">
                                    Loss
                                  </a>
                                ) : null}
                                <div className="collapse menu-dropdown" id="sidebarCrm">
                                  <ul className="nav nav-sm flex-column">

                                    {/* REPORT_LOSS_USER */}
                                    {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_USER) && (
                                      <Link to='manufacturing/report/loss/user' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                        <span
                                          style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                          onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                          onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                        >
                                          &nbsp;&nbsp;<FaUsers size={14} />
                                          &nbsp;&nbsp;&nbsp;&nbsp;User
                                        </span>
                                      </Link>
                                    )}

                                    {/* LOSS_KAPANLOSSTIMEWISE */}
                                    {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_KAPANLOSSTIMEWISE) && (
                                      <Link to='manufacturing/report/loss/kapanloss-timewise' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                        <span
                                          style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                          onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                          onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                        >
                                          &nbsp;&nbsp;<FaCalendarDay size={14} />
                                          &nbsp;&nbsp;&nbsp;&nbsp;Kapan Loss (Time Wise)
                                        </span>
                                      </Link>
                                    )}

                                    {/* LOSS_KAPANLOSS */}
                                    {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_REPORT_LOSS_KAPANLOSS) && (
                                      <Link to='manufacturing/report/loss/kapanloss' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                        <span
                                          style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                          onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                          onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                        >
                                          &nbsp;&nbsp;<TbStairsDown size={14} />
                                          &nbsp;&nbsp;&nbsp;&nbsp;Kapan Loss
                                        </span>
                                      </Link>
                                    )}

                                  </ul>
                                </div>
                              </li>

                            </ul>
                          </div>
                        </li>

                      </ul>
                    </div>
                  </li>

                  {/* Tender */}
                  <li className="nav-item">
                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_MASTER_MINE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_MASTER_COMPANY ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_OPERATION_TENDER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_OPERATION_TENDER_LOT ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_OPERATION_LOT_PLANNING ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_OPERATION_SALES_BID ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_STONE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_LOT ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_FINAL_BID_SUMMARY ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_OPERATION_MANUFACTURING_BID ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_DIRECTSTONE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.TENDER_REPORT_STATS
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#sidebarApps1"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarApps1"
                      >
                        <i>
                          <RiAuctionFill size={22} />
                        </i>
                        <span data-key="t-apps">Tender</span>
                      </a>
                    ) : null}
                    <div className="collapse menu-dropdown" id="sidebarApps1">
                      <ul className="nav nav-sm flex-column">
                        <li className="nav-item">

                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_MASTER_MINE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_MASTER_COMPANY
                          ) !== undefined ? (
                            <a
                              href="#tenderMaster"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="tenderMaster"
                              data-key="t-calender"
                            >
                              Masters
                            </a>
                          ) : null}

                          <div
                            className="collapse menu-dropdown"
                            id="tenderMaster"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* MINE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.TENDER_MASTER_MINE) && (
                                <Link to='tender/master/mine' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<GiMiner size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Mine
                                  </span>
                                </Link>
                              )}

                              {/* COMPANY */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.TENDER_MASTER_COMPANY) && (
                                <Link to='tender/master/company' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<BsBuildings size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Company
                                  </span>
                                </Link>
                              )}

                            </ul>
                          </div>
                        </li>
                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_OPERATION_TENDER ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_OPERATION_TENDER_LOT ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_OPERATION_LOT_PLANNING ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_OPERATION_SALES_BID ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_STONE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_LOT ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_OPERATION_MANUFACTURING_BID ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_FINAL_BID_SUMMARY ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_DIRECTSTONE
                          ) !== undefined ? (
                            <a
                              href="#sidebarCalendar"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="sidebarCalendar"
                              data-key="t-calender"
                            >
                              Operations
                            </a>
                          ) : null}

                          <div
                            className="collapse menu-dropdown"
                            id="sidebarCalendar"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* TENDER */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_TENDER) && (
                                <Link to='tender/operation/tender' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<IoReceipt size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Tender
                                  </span>
                                </Link>
                              )}
                            </ul>

                            <ul className="nav nav-sm flex-column">

                              {/* TENDER_LOT */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_TENDER_LOT) && (
                                <Link to='tender/operation/tenderlot' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<TbInvoice size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Tender Lot
                                  </span>
                                </Link>
                              )}
                            </ul>

                            <ul className="nav nav-sm flex-column">
                              {/* LOT PLANNING */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_LOT_PLANNING) && (
                                <Link to='tender/operation/lotplanning' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<TbCalendarDollar size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Lot Planning
                                  </span>
                                </Link>
                              )}
                            </ul>

                            <ul className="nav nav-sm flex-column">
                              {/* LOT PLANNING */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_TENDER_LOT_PLANNING) && (
                                <Link to='tender/operation/tenderlotplanning' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<TbCalendarDollar size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Tender Lot Planning
                                  </span>
                                </Link>
                              )}
                            </ul>

                            <ul className="nav nav-sm flex-column">
                              {/* BID */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_SALES_BID ||
                                iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_MANUFACTURING_BID) && (
                                  <Link to='tender/operation/bid' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<GiThorHammer size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Bid
                                    </span>
                                  </Link>
                                )}
                            </ul>

                            <ul className="nav nav-sm flex-column">

                              {/* BID PREVIEW */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_STONE ||
                                iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_LOT ||
                                iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_DIRECTSTONE ||
                                iPermission.permissionid === Constants.PERMISSIONS.TENDER_OPERATION_BID_PREVIEW_FINAL_BID_SUMMARY) && (
                                  <Link to='tender/operation/bidpreview' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<VscPreview size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Bid Preview
                                    </span>
                                  </Link>
                                )}

                            </ul>

                          </div>
                        </li>
                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.TENDER_REPORT_STATS
                          ) !== undefined ? (
                            <a
                              href="#sidebarCalendar2"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="sidebarCalendar2"
                              data-key="t-calender"
                            >
                              Report
                            </a>
                          ) : null}

                          <div
                            className="collapse menu-dropdown"
                            id="sidebarCalendar2"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* STATS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.TENDER_REPORT_STATS) && (
                                <Link to='tender/report/stats' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<MdOutlineQueryStats size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Stats
                                  </span>
                                </Link>
                              )}
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </li>

                  {/* Stone Journey */}
                  <li className="nav-item">
                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.STONEJOURNEY_MEDIABUILDER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.STONEJOURNEY_PROCESS
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#stonejourney"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="stonejourney"
                      >
                        <i>
                          <GiMountainRoad size={22} />
                        </i>
                        <span data-key="t-apps">Stone Journey</span>
                      </a>
                    ) : null}
                    <div className="collapse menu-dropdown" id="stonejourney">
                      <ul className="nav nav-sm flex-column">

                        {/* PROCESS */}
                        {Constants.USER_PERMISSION.some((iPermission) =>
                          iPermission.permissionid === Constants.PERMISSIONS.STONEJOURNEY_PROCESS) && (
                            <Link to='stonejourney/process' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<BiLoader size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Process
                              </span>
                            </Link>
                          )}

                        {/* Media Builder */}
                        {Constants.USER_PERMISSION.some((iPermission) =>
                          iPermission.permissionid === Constants.PERMISSIONS.STONEJOURNEY_MEDIABUILDER) && (
                            <Link to='stonejourney/mediabuilder' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<VscFileMedia size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Media Builder
                              </span>
                            </Link>
                          )}
                      </ul>
                    </div>
                  </li>

                  {/* Worker */}
                  <li className="nav-item">
                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid === Constants.PERMISSIONS.WORKER ||
                        iPermission.permissionid === Constants.PERMISSIONS.WORKER_IGI ||
                        iPermission.permissionid === Constants.PERMISSIONS.WORKER_HRD ||
                        iPermission.permissionid === Constants.PERMISSIONS.WORKER_GIA ||
                        iPermission.permissionid === Constants.PERMISSIONS.WORKER_SETTING
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#WorkerDash"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="WorkerDash"
                      >
                        <i className="mdi mdi-account" />
                        <span data-key="t-dashboards">Worker</span>
                      </a>
                    ) : null}
                    <div className="collapse menu-dropdown" id="WorkerDash">
                      <ul className="nav nav-sm flex-column">

                        {/* WORKER */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.WORKER) && (
                          <Link to='worker/worker' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaEdit size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Worker
                            </span>
                          </Link>
                        )}

                        {/* IGI */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.WORKER_IGI) && (
                          <Link to='worker/igicertificates' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<TbCertificate size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;IGI Certificates
                            </span>
                          </Link>
                        )}

                        {/* HRD */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.WORKER_HRD) && (
                          <Link to='worker/hrdcertificates' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<TbCertificate size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;HRD Certificates
                            </span>
                          </Link>
                        )}

                        {/* GIA */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.WORKER_GIA) && (
                          <Link to='worker/giacertificates' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<TbCertificate size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;GIA Certificates
                            </span>
                          </Link>
                        )}

                        {/* SETTING */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.WORKER_SETTING) && (
                          <Link to='worker/workersettings' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaCog size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Worker Settings
                            </span>
                          </Link>
                        )}

                      </ul>
                    </div>
                  </li>

                  {/* Utility */}
                  <li className="nav-item">
                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid === Constants.PERMISSIONS.UTILITY_DESIGNATION ||
                        iPermission.permissionid === Constants.PERMISSIONS.UTILITY_LOCATION ||
                        iPermission.permissionid === Constants.PERMISSIONS.UTILITY_COUNTRY ||
                        iPermission.permissionid === Constants.PERMISSIONS.UTILITY_STONESTATUS ||
                        iPermission.permissionid === Constants.PERMISSIONS.UTILITY_STONELABSTATUS ||
                        iPermission.permissionid === Constants.PERMISSIONS.UTILITY_MEMOSTATUS ||
                        iPermission.permissionid === Constants.PERMISSIONS.UTILITY_DOCUMENTTYPE
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#UtilityMasterDa"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="UtilityMasterDa"
                      >
                        <i className="mdi mdi-view-grid-plus-outline" />{" "}
                        <span data-key="t-apps">Utility</span>
                      </a>
                    ) : null}
                    <div className="collapse menu-dropdown" id="UtilityMasterDa">
                      <ul className="nav nav-sm flex-column">
                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid === Constants.PERMISSIONS.UTILITY_DESIGNATION ||
                              iPermission.permissionid === Constants.PERMISSIONS.UTILITY_LOCATION ||
                              iPermission.permissionid === Constants.PERMISSIONS.UTILITY_COUNTRY ||
                              iPermission.permissionid === Constants.PERMISSIONS.UTILITY_STONESTATUS ||
                              iPermission.permissionid === Constants.PERMISSIONS.UTILITY_STONELABSTATUS ||
                              iPermission.permissionid === Constants.PERMISSIONS.UTILITY_MEMOSTATUS ||
                              iPermission.permissionid === Constants.PERMISSIONS.UTILITY_DOCUMENTTYPE
                          ) !== undefined ? (
                            <a
                              href="#utilityMaster"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="utilityMaster"
                              data-key="t-calender"
                            >
                              Masters
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="utilityMaster"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* DESIGNATION */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.UTILITY_DESIGNATION) && (
                                <Link to='utility/master/designation' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<TbStairsDown size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Designation
                                  </span>
                                </Link>
                              )}

                              {/* LOCATION */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.UTILITY_LOCATION) && (
                                <Link to='utility/master/location' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaLocationArrow size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Location
                                  </span>
                                </Link>
                              )}

                              {/* COUNTRY */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.UTILITY_COUNTRY) && (
                                <Link to='utility/master/country' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<IoEarthSharp size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Country
                                  </span>
                                </Link>
                              )}

                              {/* STONESTATUS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.UTILITY_STONESTATUS) && (
                                <Link to='utility/master/stonestatus' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<MdOutlineSignalWifiStatusbar4Bar size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Stone Status
                                  </span>
                                </Link>
                              )}

                              {/* STONELABSTATUS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.UTILITY_STONELABSTATUS) && (
                                <Link to='utility/master/stonelabstatus' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<IoEarthSharp size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Stone Lab Status
                                  </span>
                                </Link>
                              )}

                              {/* MEMOSTATUS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.UTILITY_MEMOSTATUS) && (
                                <Link to='utility/master/memostatus' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaCheckSquare size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Memo Status
                                  </span>
                                </Link>
                              )}

                              {/* DOCUMENTTYPE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.UTILITY_DOCUMENTTYPE) && (
                                <Link to='utility/master/documenttype' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<IoDocumentText size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Document Type
                                  </span>
                                </Link>
                              )}

                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </li>

                  {/* Sales */}
                  <li className="nav-item">
                    {(Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        (iPermission.permissionid === Constants.PERMISSIONS.OPERATION_STOCK &&
                          Constants.loggedInUser.usertype === "E") ||
                        iPermission.permissionid === Constants.PERMISSIONS.SALES_PROFORMA ||
                        iPermission.permissionid === Constants.PERMISSIONS.SALES_CANCEL_SALE
                    ) !== undefined) ? (
                      <a
                        className="nav-link menu-link"
                        href="#SalesDash"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="SalesDash"
                      >
                        <i className="mdi mdi-chart-areaspline" />
                        <span data-key="t-dashboards">{Utility.GetBuyOrSell(true)}</span>
                      </a>
                    ) : null}
                    <div className="collapse menu-dropdown" id="SalesDash">
                      <ul className="nav nav-sm flex-column">

                        {/* PROFORMA */}
                        {(Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.SALES_PROFORMA) ||
                          (Constants.loggedInUser.usertype === "E"))
                          && (
                            <Link to='sales/proforma' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaFileInvoice size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Proforma
                              </span>
                            </Link>
                          )}

                        {/* CANCEL SALE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.SALES_CANCEL_SALE)
                          && (
                            <Link to='sales/cancelsale' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<MdCancel size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Cancel Sale
                              </span>
                            </Link>
                          )}

                      </ul>
                    </div>
                  </li>

                  {/* Report */}
                  <li className="nav-item">
                    {(Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        (iPermission.permissionid === Constants.PERMISSIONS.OPERATION_STOCK && Constants.loggedInUser.usertype !== "B") ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_USER ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_MAXMEMOREMINDERPERIODSDAYS ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_ABOVEMEMODAYS ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_MAXALLOWEDMEMOAMOUNT ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_ABOVEPAYMENTREMINDERDAYS ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_ABOVEPAYMENTDAYS ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_CUSTOMERWISEPENDINGPAYMENT ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_STOCK ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_STOCK_AS_ON_DATE ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_DAY_WISE_STONE_SALES ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_STOCKTALLY ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_STOCK_EXPORT ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_STONEHISTORY ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_STONESEARCHHISTORY ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_CONSIGNMENT ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_LABTEST_LABTEST ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_LABTEST_PENDINGREPORTRECEIVE ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_LABTEST_PENDINGSTONERECEIVE ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_ACCOUNTS_INVOICE ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_ACCOUNTS_PROFORMA ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_COMMISSION_COMMISSION ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_COMMISSION_PAYMENT ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_COMMISSION_HISTORY ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_MEMO_REPORTMEMO ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_KAPAN_KAPANSTATUSSUMMARY ||
                        iPermission.permissionid === Constants.PERMISSIONS.REPORT_PERMISSION_USERWITHOUTPERMISSION
                    ) !== undefined) ? (
                      <a
                        className="nav-link menu-link"
                        href="#ReportDatshAp"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="ReportDatshAp"
                      >
                        <i className="mdi mdi-file-chart" />
                        <span data-key="t-apps">Report</span>
                      </a>
                    ) : null}

                    <div className="collapse menu-dropdown" id="ReportDatshAp">
                      <ul className="nav nav-sm flex-column">

                        {/* CANCEL SALE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_USER)
                          && (
                            <Link to='report/user' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaUser size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;User
                              </span>
                            </Link>
                          )}

                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_USERS_MAXMEMOREMINDERPERIODSDAYS ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_USERS_ABOVEMEMODAYS ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_USERS_MAXALLOWEDMEMOAMOUNT ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_USERS_ABOVEPAYMENTREMINDERDAYS ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_USERS_ABOVEPAYMENTDAYS ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_USERS_CUSTOMERWISEPENDINGPAYMENT ||
                              (iPermission.permissionid === Constants.PERMISSIONS.OPERATION_STOCK &&
                                Constants.loggedInUser.usertype === "E")
                          ) !== undefined ? (
                            <a
                              href="#RepoerUSers"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="RepoerUSers"
                              data-key="t-calender"
                            >
                              Users
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="RepoerUSers"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* MAXMEMOREMINDERPERIODSDAYS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_MAXMEMOREMINDERPERIODSDAYS)
                                && (
                                  <Link to='report/users/maxmemoreminderperioddays' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      <FaCalendar size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Max Memo Reminder Period Days
                                    </span>
                                  </Link>
                                )}

                              {/* ABOVEMEMODAYS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_ABOVEMEMODAYS)
                                && (
                                  <Link to='report/users/abovememodays' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      <FaCalendarAlt size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Above Memo Days
                                    </span>
                                  </Link>
                                )}


                              {/* MAXALLOWEDMEMOAMOUNT */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_MAXALLOWEDMEMOAMOUNT)
                                && (
                                  <Link to='report/users/maxallowedmemoamount' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      <FaMoneyCheckAlt size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Max Allowed Memo Amount
                                    </span>
                                  </Link>
                                )}

                              {/* ABOVEPAYMENTREMINDERDAYS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_ABOVEPAYMENTREMINDERDAYS)
                                && (
                                  <Link to='report/users/abovepaymentreminderdays' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      <FaCalendarCheck size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Above Payment Reminder Days
                                    </span>
                                  </Link>
                                )}

                              {/* ABOVEPAYMENTDAYS */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_USERS_ABOVEPAYMENTDAYS)
                                && (
                                  <Link to='report/users/abovepaymentdays' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      <MdPayment size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Above Payment Days
                                    </span>
                                  </Link>
                                )}

                              {/* CUSTOMER WISE PENDING PAYMENT */}
                              {Constants.loggedInUser.usertype !== "B"
                                && (
                                  <Link to='report/users/customerwisependingpayment' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      <FaUser size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Customer Wise Pending Payment
                                    </span>
                                  </Link>
                                )}

                            </ul>
                          </div>
                        </li>

                        {/* STOCK */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_STOCK)
                          && (
                            <Link to='report/stock' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<IoDiamondOutline size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Stock
                              </span>
                            </Link>
                          )}

                        {/* STOCK AS ON DATE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_STOCK_AS_ON_DATE)
                          && (
                            <Link to='report/stock/ondate' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<IoDiamondOutline size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Stock As On Date
                              </span>
                            </Link>
                          )}

                        {/* DAY WISE STONE SALES */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_DAY_WISE_STONE_SALES)
                          && (
                            <Link to='report/daywisestonesales' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<IoDiamondOutline size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Day Wise Stone Sales
                              </span>
                            </Link>
                          )}

                        {/* STOCK TALLY */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_STOCKTALLY)
                          && (
                            <Link to='report/stocktally' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<MdAddChart size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Stock Tally
                              </span>
                            </Link>
                          )}

                        {/* STOCK EXPORT */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_STOCK_EXPORT)
                          && (
                            <Link to='report/stockexport' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<MdTransferWithinAStation size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Stock Export
                              </span>
                            </Link>
                          )}

                        {/* STONE HISTORY */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_STONEHISTORY)
                          && (
                            <Link to='report/stonehistory' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaBook size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Stock History
                              </span>
                            </Link>
                          )}

                        {/* STONE SEARCH HISTORY */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_STONESEARCHHISTORY)
                          && (
                            <Link to='report/stonesearchhistory' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<AiOutlineFileSearch size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Stock Search History
                              </span>
                            </Link>
                          )}

                        {/* CONSIGNMENT */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_CONSIGNMENT)
                          && (
                            <Link to='report/consignment' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<AiOutlineFileSearch size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Consignment
                              </span>
                            </Link>
                          )}

                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_LABTEST_LABTEST ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_LABTEST_PENDINGREPORTRECEIVE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_LABTEST_PENDINGSTONERECEIVE
                          ) !== undefined ? (
                            <a
                              href="#RepoerUSersLasb"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="RepoerUSersLasb"
                              data-key="t-calender"
                            >
                              Lab test
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="RepoerUSersLasb"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* LABTEST */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_LABTEST_LABTEST)
                                && (
                                  <Link to='report/labtest/labtest' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<IoIosFlask size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Lab Test
                                    </span>
                                  </Link>
                                )}

                              {/* PENDINGREPORTRECEIVE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_LABTEST_PENDINGREPORTRECEIVE)
                                && (
                                  <Link to='report/labtest/pendingreportreceive' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<RiFolderReceivedFill size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Pending Report Receive
                                    </span>
                                  </Link>
                                )}

                              {/* PENDINGSTONERECEIVE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_LABTEST_PENDINGSTONERECEIVE)
                                && (
                                  <Link to='report/labtest/pendingstonereceive' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<IoSend size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Pending Stone Receive
                                    </span>
                                  </Link>
                                )}

                            </ul>
                          </div>
                        </li>

                        {Constants.loggedInUser.usertype !== "B" ? (
                          <li className="nav-item">
                            <a
                              href="#ReportUserSales"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="ReportUserSales"
                              data-key="t-calender"
                            >
                              {Utility.GetBuyOrSell(true)}
                            </a>

                            <div
                              className="collapse menu-dropdown"
                              id="ReportUserSales"
                            >
                              <ul className="nav nav-sm flex-column">

                                {/* INVOICE */}
                                <Link to='report/sales/invoice' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaFileInvoiceDollar size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Invoice
                                  </span>
                                </Link>

                                {/* PROFORMA */}
                                <Link to='report/sales/proforma' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaFileInvoice size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Proforma
                                  </span>
                                </Link>

                              </ul>
                            </div>
                          </li>
                        ) : null}

                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_ACCOUNTS_INVOICE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_ACCOUNTS_PROFORMA
                          ) !== undefined ? (
                            <a
                              href="#ReportUserAccount"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="ReportUserAccount"
                              data-key="t-calender"
                            >
                              Accounts
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="ReportUserAccount"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* ACCOUNTS PROFORMA */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_ACCOUNTS_PROFORMA)
                                && (
                                  <Link to='report/accounts/proforma' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<FaFileInvoice size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Proforma
                                    </span>
                                  </Link>
                                )}

                              {/* ACCOUNTS INVOICE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_ACCOUNTS_INVOICE)
                                && (
                                  <Link to='report/accounts/invoice' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      &nbsp;&nbsp;<FaFileInvoiceDollar size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Invoice
                                    </span>
                                  </Link>
                                )}

                            </ul>
                          </div>
                        </li>

                        {/*  COMMISSION */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_COMMISSION_COMMISSION ||
                          iPermission.permissionid === Constants.PERMISSIONS.REPORT_COMMISSION_PAYMENT ||
                          iPermission.permissionid === Constants.PERMISSIONS.REPORT_COMMISSION_HISTORY)
                          && (
                            <Link to='report/commission' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<GiTakeMyMoney size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Commission
                              </span>
                            </Link>
                          )}

                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_MEMO_REPORTMEMO
                          ) !== undefined ? (
                            <a
                              href="#RepoerUSersMemio"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="RepoerUSersMemio"
                              data-key="t-calender"
                            >
                              Memo
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="RepoerUSersMemio"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/*  REPORT MEMO */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_MEMO_REPORTMEMO) && (
                                <Link to='report/memo/reportmemo' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaRegFolderOpen size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Report Memo
                                  </span>
                                </Link>
                              )}
                            </ul>
                          </div>
                        </li>

                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_KAPAN_KAPANSTATUSSUMMARY
                          ) !== undefined ? (
                            <a
                              href="#RepoerUSersKapan"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="RepoerUSersKapan"
                              data-key="t-calender"
                            >
                              Kapan
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="RepoerUSersKapan"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/*  KAPAN STATUS SUMMARY*/}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_KAPAN_KAPANSTATUSSUMMARY) && (
                                <Link to='report/kapan/kapanstatussummary' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaRegFolderOpen size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Kapan Status Summary
                                  </span>
                                </Link>
                              )}

                            </ul>
                          </div>
                        </li>

                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.REPORT_PERMISSION_USERWITHOUTPERMISSION
                          ) !== undefined ? (
                            <a
                              href="#RepoerUSersPermission"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="RepoerUSersPermission"
                              data-key="t-calender"
                            >
                              Permission
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="RepoerUSersPermission"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/*  USER WITHOUT PERMISSION */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.REPORT_PERMISSION_USERWITHOUTPERMISSION) && (
                                <Link to='report/permission/userwithoutpermission' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    &nbsp;&nbsp;<FaUserTimes size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;User Without Permission
                                  </span>
                                </Link>
                              )}
                            </ul>
                          </div>
                        </li>

                      </ul>
                    </div>
                  </li>

                  {/* Analysis */}
                  <li className="nav-item">
                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_NIVODA_CRITERIA ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_NIVODA_PRICING ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_NIVODA_STOCK ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_NIVODA_SHAPE_MAPPING ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_WOLZA_EXCELUPLOAD ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_WOLZA_CONSIGNEEMASTER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_WOLZA_MAPCONSIGNEE_CREATE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_WOLZA_MAPCONSIGNEE_MANAGE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_WOLZA_MARKETSELL ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_NIVODA_USER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.ANALYSIS_DNKDATA_INVOICEUPLOAD
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#AnalysisDash"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="AnalysisDash"
                      >
                        <i className="mdi mdi-google-analytics" />
                        <span data-key="t-apps">Analysis</span>
                      </a>
                    ) : null}
                    <div className="collapse menu-dropdown" id="AnalysisDash">
                      <ul className="nav nav-sm flex-column">
                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_NIVODA_CRITERIA ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_NIVODA_PRICING ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_NIVODA_STOCK ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_NIVODA_SHAPE_MAPPING ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_NIVODA_USER
                          ) !== undefined ? (
                            <a
                              href="#Nivoda"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="Nivoda"
                              data-key="t-calender"
                            >
                              Nivoda
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="Nivoda"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/*  NIVODA USER */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_NIVODA_USER) && (
                                <Link to='analysis/nivoda/user' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    <FaUser size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;User
                                  </span>
                                </Link>
                              )}

                              {/* NIVODA SHAPE MAPPING */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_NIVODA_SHAPE_MAPPING) && (
                                <Link to='analysis/nivoda/shapemapping' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    <LuShapes size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Shape Mapping
                                  </span>
                                </Link>
                              )}

                              {/* NIVODA CRITERIA */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_NIVODA_CRITERIA) && (
                                <Link to='analysis/nivoda/criteria' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    <LuListChecks size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Criteria
                                  </span>
                                </Link>
                              )}

                              {/* NIVODA PRICING */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_NIVODA_PRICING) && (
                                <Link to='analysis/nivoda/pricing' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    <CgDollar size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Pricing
                                  </span>
                                </Link>
                              )}

                              {/* NIVODA STOCK */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_NIVODA_STOCK) && (
                                <Link to='analysis/nivoda/stock' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    <GoStack size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Nivoda Stock
                                  </span>
                                </Link>
                              )}

                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="collapse menu-dropdown" id="AnalysisDash">
                      <ul className="nav nav-sm flex-column">
                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_WOLZA_EXCELUPLOAD ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_WOLZA_CONSIGNEEMASTER ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_WOLZA_MAPCONSIGNEE_CREATE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_WOLZA_MAPCONSIGNEE_MANAGE ||
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_WOLZA_MARKETSELL
                          ) !== undefined ? (
                            <a
                              href="#Wolza"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="Wolza"
                              data-key="t-calender"
                            >
                              Wolza
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="Wolza"
                          >
                            <ul className="nav nav-sm flex-column">

                              {/* WOLZA CONSIGNEE MASTER */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_WOLZA_CONSIGNEEMASTER) && (
                                <Link to='analysis/wolza/consigneemaster' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    <RiUserReceived2Fill size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Consignee Master
                                  </span>
                                </Link>
                              )}

                            </ul>
                            <ul className="nav nav-sm flex-column">

                              {/* WOLZA MAP CONSIGNEE */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_WOLZA_MAPCONSIGNEE_CREATE ||
                                iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_WOLZA_MAPCONSIGNEE_MANAGE) && (
                                  <Link to='analysis/wolza/mapconsignee' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                    <span
                                      style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                      onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                      onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                    >
                                      <FaLink size={14} />
                                      &nbsp;&nbsp;&nbsp;&nbsp;Map Consignee
                                    </span>
                                  </Link>
                                )}

                            </ul>
                            <ul className="nav nav-sm flex-column">

                              {/* WOLZA EXCEL UPLOAD */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_WOLZA_EXCELUPLOAD) && (
                                <Link to='analysis/wolza/excelupload' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    <RiFileExcel2Fill size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Excel Upload
                                  </span>
                                </Link>
                              )}

                            </ul>
                            <ul className="nav nav-sm flex-column">

                              {/* WOLZA MARKET SELL */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_WOLZA_MARKETSELL) && (
                                <Link to='analysis/wolza/marketsell' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    <IoDiamondOutline size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Market Sell
                                  </span>
                                </Link>
                              )}
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="collapse menu-dropdown" id="AnalysisDash">
                      <ul className="nav nav-sm flex-column">
                        <li className="nav-item">
                          {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                              iPermission.permissionid ===
                              Constants.PERMISSIONS.ANALYSIS_DNKDATA_INVOICEUPLOAD
                          ) !== undefined ? (
                            <a
                              href="#DnkData"
                              className="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              aria-controls="DnkData"
                              data-key="t-calender"
                            >
                              DNK Data
                            </a>
                          ) : null}
                          <div
                            className="collapse menu-dropdown"
                            id="DnkData"
                          >
                            <ul className="nav nav-sm flex-column">
                              {/* DNKD INVOICE UPLOAD */}
                              {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.ANALYSIS_DNKDATA_INVOICEUPLOAD) && (
                                <Link to='analysis/dnkdata/invoiceupload' style={{ textDecoration: "none", marginBottom: "10px" }}>
                                  <span
                                    style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                    onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                    onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                                  >
                                    <FaFileUpload size={14} />
                                    &nbsp;&nbsp;&nbsp;&nbsp;Upload Data
                                  </span>
                                </Link>
                              )}

                            </ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </li>

                  {/* Permission */}
                  <li className="nav-item">
                    {Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_PERMISSION ||
                        iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_VIRTUALTEAM ||
                        iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_ROLE ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.PERMISSION_USERPERMISSION_USER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.PERMISSION_USERPERMISSION_USERS ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.PERMISSION_USERPERMISSION_VIRTUALTEAM ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.PERMISSION_USERPERMISSION_PERMISSION ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.PERMISSION_USERPERMISSION_PERMISSIONS ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.PERMISSION_USERROLE_USER ||
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.PERMISSION_USERROLE_VIRTUALTEAM
                    ) !== undefined ? (
                      <a
                        className="nav-link menu-link"
                        href="#sidebarOperationsPerm"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarOperationsPerm"
                      >
                        <i className="mdi mdi-account-key" />
                        <span data-key="t-dashboards">Permission</span>
                      </a>
                    ) : null}

                    <div className="collapse menu-dropdown" id="sidebarOperationsPerm">

                      <ul className="nav nav-sm flex-column">

                        {/* PERMISSION  */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_PERMISSION) && (
                          <Link to='permission/permission' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<MdVerified size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Permission
                            </span>
                          </Link>
                        )}

                        {/* VIRTUAL TEAM  */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_VIRTUALTEAM) && (
                          <Link to='permission/virtualteam' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaUsers size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Virtual Team
                            </span>
                          </Link>
                        )}

                        {/* ROLE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_ROLE) && (
                          <Link to='permission/role' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaPencilAlt size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Role
                            </span>
                          </Link>
                        )}

                        {/* COLUMN ROLE */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_COLUMNROLE) && (
                          <Link to='permission/columnrole' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaPencilAlt size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;Column Role
                            </span>
                          </Link>
                        )}

                        {/* USER PERMISSION*/}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERPERMISSION_USER ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERPERMISSION_USERS ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERPERMISSION_VIRTUALTEAM ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERPERMISSION_PERMISSION ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERPERMISSION_PERMISSIONS) && (
                            <Link to='permission/userpermission' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaUserCheck size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;User Permission
                              </span>
                            </Link>
                          )}

                        {/* USER COLUMN PERMISSION*/}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERCOLUMNPERMISSION_USER ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERCOLUMNPERMISSION_USERS ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERCOLUMNPERMISSION_VIRTUALTEAM ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERCOLUMNPERMISSION_PERMISSION ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERCOLUMNPERMISSION_PERMISSIONS) && (
                            <Link to='permission/usercolumnpermission' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaUserCheck size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;User Column Permission
                              </span>
                            </Link>
                          )}

                        {/* USER ROLE*/}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERROLE_USER ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERROLE_VIRTUALTEAM) && (
                            <Link to='permission/userrole' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaUserEdit size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;User Role
                              </span>
                            </Link>
                          )}

                        {/* USER COLUMN ROLE*/}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERCOLUMNROLE_USER ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERCOLUMNROLE_VIRTUALTEAM) && (
                            <Link to='permission/usercolumnrole' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaUserEdit size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;User Column Role
                              </span>
                            </Link>
                          )}

                      </ul>
                    </div>
                  </li>

                  {/* Settings */}
                  <li className="nav-item">
                    <a
                      className="nav-link menu-link"
                      href="#sidebarOperationsSettings"
                      data-bs-toggle="collapse"
                      role="button"
                      aria-expanded="false"
                      aria-controls="sidebarOperationsSettings"
                    >
                      <i className="mdi mdi-account-settings" />
                      <span data-key="t-dashboards">Settings</span>
                    </a>
                    <div className="collapse menu-dropdown" id="sidebarOperationsSettings">

                      <ul className="nav nav-sm flex-column">

                        {/* SETTING */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.SETTING ||
                          iPermission.permissionid === Constants.PERMISSIONS.PERMISSION_USERROLE_VIRTUALTEAM) && (
                            <Link to='setting' style={{ textDecoration: "none", marginBottom: "10px" }}>
                              <span
                                style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                                onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                                onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                              >
                                &nbsp;&nbsp;<FaCog size={14} />
                                &nbsp;&nbsp;&nbsp;&nbsp;Settings
                              </span>
                            </Link>
                          )}

                        {/* USER SETTING */}
                        {Constants.USER_PERMISSION.some((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.SETTING_USERSETTING) && (
                          <Link to='usersetting' style={{ textDecoration: "none", marginBottom: "10px" }}>
                            <span
                              style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                              onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                              onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                            >
                              &nbsp;&nbsp;<FaUserCog size={14} />
                              &nbsp;&nbsp;&nbsp;&nbsp;User Settings
                            </span>
                          </Link>
                        )}

                        {/* COLUMN ORDER SETTINGS */}
                        <Link to='columnordersetting' style={{ textDecoration: "none", marginBottom: "10px" }}>
                          <span
                            style={{ color: "#a3a6b7", cursor: "pointer", fontSize: "14px" }}
                            onMouseEnter={(e) => (e.target.style.color = "#FFFFFF")}
                            onMouseLeave={(e) => (e.target.style.color = "#a3a6b7")}
                          >
                            &nbsp;&nbsp;<FaUserCog size={14} />
                            &nbsp;&nbsp;&nbsp;&nbsp;Column Order Settings
                          </span>
                        </Link>

                      </ul>
                    </div>
                  </li>

                  {/* HELP */}
                  <li className="nav-item">
                    <Link to='help'
                      className="nav-link menu-link"
                      role="button"
                    >
                      <i className="mdi mdi-help" />
                      <span data-key="t-widgets">Help</span>
                    </Link>
                  </li>
                </ul>
              </div>
              {/* Sidebar */}
            </div>
            <div className="sidebar-background" />
          </div>
          {this.state.showChangePasswordModal && (
            <ChangePasswordModal
              Show={true}
              handleClose={this.hideChangePasswordModal}
              handleSave={this.changePassword}
              handleValidation={this.handleValidation}
              sourceData={Constants.loggedInUser}
            />
          )}
          {this.state.showEditProfileModal && (
            <EditCustomerDetailsModal
              Show={true}
              handleClose={this.hideEditProfileModal}
              handleSave={this.editUserAllDetails}
              handleValidation={this.handleValidation}
              editOperation={true}
              sourceData={this.state.data}
              loading={this.state.loadingButton}
              saveButton={true}
              permission={[]}
            />
          )}
          {/* Left Sidebar End */}
          {/* Vertical Overlay*/}
          <div className="vertical-overlay" />
          {/* ============================================================== */}
          {/* Start right Content here */}
          {/* ============================================================== */}
          <div className="main-content">
            <div style={{ padding: "50px calc(1.5rem * 0.5) 40px calc(1.5rem * 0.5)" }}>
              {/* <Router> */}

              <Routes>

                <Route path="/" element={Constants.loggedInUser.usertype !== 'E' ? <Navigate to="/app/operation/stock" replace /> : <Navigate to="/app/dashboard" replace />} />
                <Route path="/dashboard" element={<WelcomeDashboard />} />

                {/* Login*/}

                <Route path="/managecustomerprofile" element={<ManageCustomerProfile />} />

                {/* Master */}

                <Route path="/master/user" element={<UserMaster />} />
                <Route path="/master/employee" element={<EmployeeMaster />} />
                <Route path="/master/customer" element={<CustomerMaster />} />
                <Route path="/master/reassigncustomer" element={<ReassignCustomer />} />
                <Route path="/master/potentialsell" element={<PotentialSell />} />
                <Route path="/master/broker" element={<BrokerMaster />} />
                <Route path="/master/lab" element={<LabMaster />} />
                <Route path="/master/tradingcompany" element={<TradingcompanyMaster />} />
                <Route path="/master/rapnetlogins" element={<RapnetLoginMaster />} />

                {/* Operation */}

                <Route path="/operation/stock" element={<Stock />} />
                <Route path="/operation/selloutsource" element={<SellToOutsource />} />
                <Route path="/operation/rapnetoperation" element={<RapnetOperation />} />
                <Route path="/operation/labtest" element={<LabTest />} />
                <Route path="/operation/recheck" element={<ReCheck />} />
                <Route path="/operation/memo" element={<MemoMaster />} />
                <Route path="/operation/newstone" element={<NewStone />} />
                <Route path="/operation/change-receivelocation" element={<ChangeReceiveLocation />} />
                <Route path="/operation/holdstones" element={<HoldStoneMaster />} />
                <Route path="/operation/offer" element={<OfferTab />} />
                <Route path="/operation/revise" element={<Revise />} />
                <Route path="/operation/stocktally" element={<StockTallyMain />} />
                <Route path="/operation/mediatransfer" element={<ForceMediaTransfer />} />
                <Route path="/operation/stonepotential" element={<StonePotential />} />
                <Route path="/operation/revertprice" element={<RevertPrice />} />

                {/* Mix Diamond */}

                <Route path="/mixdiamond/master/shape" element={<MixShapeMaster />} />
                <Route path="/mixdiamond/master/size" element={<MixSizeMaster />} />
                <Route path="/mixdiamond/master/clarity" element={<MixClarityMaster />} />
                <Route path="/mixdiamond/master/color" element={<MixColorMaster />} />
                <Route path="/mixdiamond/bucket" element={<MixBucketMaster />} />
                <Route path="/mixdiamond/operation/purchase" element={<MixPurchaseMaster />} />
                <Route path="/mixdiamond/operation/sales" element={<MixSalesMaster />} />
                <Route path="/mixdiamond/proforma" element={<MixSalesProforma />} />
                <Route path="/mixdiamond/cancelsale" element={<CancelMixSale />} />
                <Route path="/mixdiamond/report/viewstock" element={<MixViewStockMaster />} />
                <Route path="/mixdiamond/report/purchase" element={<MixReportPurchaseMaster />} />
                <Route path="/mixdiamond/report/sales" element={<MixReportSaleMaster />} />
                <Route path="/mixdiamond/report/buckettransaction" element={<MixReportBucketTransaction />} />
                <Route path="/mixdiamond/report/mixavg" element={<MixReportAvg />} />
                <Route path="/mixdiamond/report/mixinvoice" element={<MixSellInvoice />} />
                <Route path="/mixdiamond/report/mixproforma" element={<MixSellProforma />} />
                <Route path="/mixdiamond/report/mixcommission" element={<MixCommissionReport />} />
                <Route path="/mixdiamond/report/customerwisependingpayment" element={<MixCustomerWisePendingPayment />} />
                <Route path="/mixdiamond/report/account/mixinvoice" element={<MixInvoiceAccount />} />
                <Route path="/mixdiamond/report/account/mixproforma" element={<MixProformaAccount />} />
                <Route path="/mixdiamond/report/daywisemixstonesales" element={<DayWiseMixStoneSales />} />

                {/* Generic */}

                <Route path="/generic-master/eyeclean" element={<EyecleanMaster />} />
                <Route path="/generic-master/inclusion" element={<InclusionMaster />} />
                <Route path="/generic-master/luster" element={<LusterMaster />} />
                <Route path="/generic-master/tinge" element={<TingeMaster />} />
                <Route path="/generic-master/hna" element={<HNAMaster />} />
                <Route path="/generic-master/open" element={<OpenMaster />} />
                <Route path="/generic-master/milky" element={<MilkyMaster />} />
                <Route path="/generic-master/culet" element={<CluletMaster />} />
                <Route path="/generic-master/shade" element={<ShadeMaster />} />
                <Route path="/generic-master/keytosymbol" element={<KeytosymbolMaster />} />
                <Route path="/generic-master/businesstype" element={<BusinesstypeMaster />} />
                <Route path="/generic-master/quality" element={<QualityMaster />} />
                <Route path="/generic-master/exchangerate" element={<ExchangerateMaster />} />
                <Route path="/generic-master/size" element={<SizeMaster />} />
                <Route path="/generic-master/cut" element={<CutMaster />} />
                <Route path="/generic-master/fluoresence" element={<FloMaster />} />
                <Route path="/generic-master/shape" element={<ShapeMaster />} />
                <Route path="/generic-master/polish" element={<PolMaster />} />
                <Route path="/generic-master/color" element={<ColorMaster />} />
                <Route path="/generic-master/fancycolor" element={<FancyColorMaster />} />
                <Route path="/generic-master/clarity" element={<ClarityMaster />} />
                <Route path="/generic-master/symmetry" element={<SymMaster />} />
                <Route path="/generic-master/cutpolsym" element={<CutpolsymMaster />} />
                <Route path="/generic-master/box" element={<BoxMaster />} />
                <Route path="/generic-master/stonetype" element={<StoneTypeMaster />} />
                <Route path="/generic-master/tableinc" element={<TableIncMaster />} />
                <Route path="/generic-master/sideinc" element={<SideIncMaster />} />

                {/* Manufacturing */}

                <Route path="/manufacturing/master/departmentgroup" element={<DepartmentGroupMaster />} />
                <Route path="/manufacturing/master/department" element={<DepartmentMaster />} />
                <Route path="/manufacturing/master/process" element={<ProcessMaster />} />
                <Route path="/manufacturing/master/userprocess" element={<UserProcessMaster />} />
                <Route path="/manufacturing/master/remarkcategory" element={<RemarkMaster />} />
                <Route path="/manufacturing/master/losscategory" element={<LossMaster />} />
                <Route path="/manufacturing/operation/lotintimation" element={<LotIntimationMaster />} />
                <Route path="/manufacturing/operation/lotcreation" element={<LotCreationMaster />} />
                <Route path="/manufacturing/operation/kapancreation" element={<KapanCreationMaster />} />
                <Route path="/manufacturing/operation/kapan-issuereceive" element={<KapanIssueReceiveMaster />} />
                <Route path="/manufacturing/operation/packet-issuereceive" element={<PacketIssueReceiveAssignMaster />} />
                <Route path="/manufacturing/operation/reprintbarcode" element={<ReprintBarcode />} />
                <Route path="/manufacturing/operation/videourl" element={<VideoUrl />} />
                <Route path="/manufacturing/operation/convertpacket" element={<ConvertPacket />} />
                <Route path="/manufacturing/operation/priceplanning" element={<Planning />} />
                <Route path="/manufacturing/report/pendinglotreceive" element={<PendingLotReceive />} />
                <Route path="/manufacturing/report/kapan" element={<KapanList />} />
                <Route path="/manufacturing/report/kapanhistory" element={<KapanHistoryDetail />} />
                <Route path="/manufacturing/report/loss/user" element={<UserLossReport />} />
                <Route path="/manufacturing/report/loss/kapanloss-timewise" element={<KapanLossTimeWiseReport />} />
                <Route path="/manufacturing/report/loss/kapanloss" element={<KapanLossListReport />} />

                {/* Tender */}
                <Route path="/tender/master/mine" element={<MineMaster />} />
                <Route path="/tender/master/company" element={<CompanyMaster />} />
                <Route path="/tender/operation/tender" element={<Tender />} />
                <Route path="/tender/operation/tenderlot" element={<TenderLot />} />
                <Route path="/tender/operation/lotplanning" element={<LotPlanning />} />
                <Route path="/tender/operation/tenderlotplanning" element={<TenderLotPlanning />} />
                <Route path="/tender/operation/bid" element={<Bid />} />
                <Route path="/tender/operation/bidpreview" element={<BidPreview />} />
                <Route path="/tender/report/stats" element={<TenderStats />} />

                {/* Worker */}

                <Route path="/worker/worker" element={<WorkerMaster />} />
                <Route path="/worker/igicertificates" element={<IGIMaster />} />
                <Route path="/worker/hrdcertificates" element={<HRDMaster />} />
                <Route path="/worker/giacertificates" element={<GIAMaster />} />
                <Route path="/worker/workersettings" element={<WorkerSetting />} />

                {/* Utility */}

                <Route path="/utility/master/designation" element={<DesignationMaster />} />
                <Route path="/utility/master/location" element={<LocationMaster />} />
                <Route path="/utility/master/country" element={<CountryMaster />} />
                <Route path="/utility/master/stonestatus" element={<StonestatusMaster />} />
                <Route path="/utility/master/stonelabstatus" element={<StoneLabstatusMaster />} />
                <Route path="/utility/master/memostatus" element={<MemostatusMaster />} />
                <Route path="/utility/master/documenttype" element={<DocumentTypeMaster />} />

                {/* Sales */}

                <Route path="/sales/proforma" element={<Proforma />} />
                <Route path="/sales/cancelsale" element={<CancelSale />} />

                {/* QUick Media Builder */}
                <Route path="/stonejourney/process" element={<StoneJourneyProcessMaster />} />
                <Route path="/stonejourney/mediabuilder" element={<MediaBuilder />} />

                {/* Report */}

                <Route path="/report/user" element={<UserReport />} />
                <Route path="/report/users/maxmemoreminderperioddays" element={<MaxMemoReminderPeriodDays />} />
                <Route path="/report/users/abovememodays" element={<AboveMemoDays />} />
                <Route path="/report/users/maxallowedmemoamount" element={<MaxAllowedMemoAmount />} />
                <Route path="/report/users/abovepaymentreminderdays" element={<AbovePaymentReminderDays />} />
                <Route path="/report/users/abovepaymentdays" element={<AbovePaymentDays />} />
                <Route path="/report/users/customerwisependingpayment" element={<CustomerWisePendingPayment />} />
                <Route path="/report/stock" element={<StoneReport />} />
                <Route path="/report/daywisestonesales" element={<DayWiseStoneSales />} />
                <Route path="/report/stock/ondate" element={<StoneAsOnDate />} />
                <Route path="/report/stonehistory" element={<StoneHistoryReport />} />
                <Route path="/report/stonesearchhistory" element={<StoneSearchHistory />} />
                <Route path="/report/labtest/labtest" element={<LabTestReport />} />
                <Route path="/report/labtest/pendingreportreceive" element={<PendingReportReceived />} />
                <Route path="/report/labtest/pendingstonereceive" element={<PendingStoneReceived />} />
                <Route path="/report/sales/invoice" element={<InvoiceReport />} />
                <Route path="/report/sales/proforma" element={<ProformaReport />} />
                <Route path="/report/accounts/invoice" element={<InvoiceAccount />} />
                <Route path="/report/accounts/proforma" element={<ProformaAccount />} />
                <Route path="/report/commission" element={<CommisionReport />} />
                <Route path="/report/memo/reportmemo" element={<MemoReport />} />
                <Route path="/report/kapan/kapanstatussummary" element={<KapanSummary />} />
                <Route path="/report/permission/userwithoutpermission" element={<UserWithoutPermission />} />
                <Route path="/report/stocktally" element={<StockTally />} />
                <Route path="/report/stockexport" element={<StockExport />} />
                <Route path="/report/consignment" element={<ConsignmentReport />} />

                {/* analysis */}
                <Route path="/analysis/nivoda/user" element={<NivodaUserMaster />} />
                <Route path="/analysis/nivoda/shapemapping" element={<ShapeMapping />} />
                <Route path="/analysis/nivoda/criteria" element={<NivodaCriteria />} />
                <Route path="/analysis/nivoda/pricing" element={<Pricing />} />
                <Route path="/analysis/nivoda/stock" element={<NivodaStock />} />
                <Route path="/analysis/wolza/excelupload" element={<ExcelUpload />} />
                <Route path="/analysis/wolza/consigneemaster" element={<ConsigneeMaster />} />
                <Route path="/analysis/wolza/mapconsignee" element={<MapConsigneeMaster />} />
                <Route path="/analysis/wolza/marketsell" element={<WolzaMarketSell />} />
                <Route path="/analysis/dnkdata/invoiceupload" element={<DnkInvoiceUpload />} />

                {/* permission */}

                <Route path="/permission/permission" element={<PermissionMaster />} />
                <Route path="/permission/virtualteam" element={<VirtualTeamMaster />} />
                <Route path="/permission/role" element={<RoleMaster />} />
                <Route path="/permission/userpermission" element={<UserPermissionMaster />} />
                <Route path="/permission/usercolumnpermission" element={<UserColumnPermissionMaster />} />
                <Route path="/permission/userrole" element={<UserRoleMaster />} />
                <Route path="/permission/columnrole" element={<ColumnRoleMaster />} />
                <Route path="/permission/usercolumnrole" element={<UserColumnRoleMaster />} />

                {/* Settings */}

                <Route path="/setting" element={<SettingsMaster />} />
                <Route path="/usersetting" element={<UsersettingsMaster />} />
                <Route path="/columnordersetting" element={<ColumnOrderSettingsMaster />} />

                {/* Help */}

                <Route path="/help" element={<Help />} />

                {/* docs */}

                <Route path="/help/api" element={<ApiDocs />} />

                {/* Watchlist */}

                <Route path="/watchlist" element={<Watchlist />} />

                {/* Not Found */}

                <Route path="*" element={<NotFound />} />

              </Routes>

              <footer
                className="footer"
                style={{
                  bottom: 0,
                  padding: "10px calc(1.5rem * .5)",
                  height: "40px"
                }}
              >
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-6">© Pansuriya Impex.</div>
                    <div className="col-sm-6">
                      <div className="text-sm-end d-none d-sm-block">
                        Design &amp; Develop by Pansuriya Impex
                      </div>
                    </div>
                  </div>
                </div>
              </footer>
              {/* </Router > */}
            </div>
            {/* End Page-content */}

          </div>
          {/* end main content*/}
        </div >
        {/* END layout-wrapper */}
        {/*start back-to-top*/}
        <button
          onClick={this.scrollToTop}
          className="btn btn-danger btn-icon"
          id="back-to-top"
          style={{ display: isVisible ? 'block' : 'none' }}
        >
          <i className="ri-arrow-up-line" />
        </button>
        {/*end back-to-top*/}

      </div>


    );
  }
}

export default withCookies(PageBody);
